const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign Up",
        plan: {
          selected: "Selected Plan",
        },
        toasts: {
          success: "User successfully created! Please log in!",
          disabled:
            "User registration is currently disabled. Please try again later.",
          fail: "Error creating user. Please check the provided data.",
        },
        errors: {
          registrationAlreadyExists: "An account is already associated with the provided email or document.",
          loginLink: "If you already have an account, log in to continue.",
          loginButton: "Log in",
        },
        country: {
          label: "Country",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          company: "Organization Name",
          companyName: "Legal Name",
          tradeName: "Trade Name",
          personName: "Full Name",
          phone: "WhatsApp (Area Code + Number)",
        },
        buttons: {
          continue: "Continue",
          submit: "Register",
          login: "Already have an account? Log in!",
        },
        step2: {
          reviewTitle: "Review your data",
          manualTitle: "Complete your registration",
          foundDataMessage: "We found some data associated with your document.",
          documentLabel: "Document",
          backButton: "Back and change document",
        },
      },
      login: {
        title: "Login",
        welcome: "Welcome back",
        loginInstruction: "Enter your credentials to access your account",
        form: {
          email: "Email",
          password: "Password",
          button: "Access",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      companies: {
        title: "Register Company",
        form: {
          name: "Company Name",
          plan: "Plan",
          token: "Token",
          submit: "Register",
          success: "Company successfully created!",
        },
      },

      auth: {
        toasts: {
          success: "Login successful!",
        },
        dueDate: {
          expiration: "Your subscription expires in",
          days: "days!",
          day: "day!",
          expirationToday: "Your subscription expires today!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filters",
        filter: "FILTER ",
        tabs: {
          indicators: "Indicators",
          assessments: "NPS",
          attendants: "Agents",
        },
        charts: {
          perDay: {
            title: "Attendances today: ",
          },
        },
        cards: {
          inAttendance: "In Attendance",
          waiting: "Waiting",
          activeAttendants: "Active Agents",
          finalized: "Finalized",
          newContacts: "New Contacts",
          totalReceivedMessages: "Received Messages",
          totalSentMessages: "Sent Messages",
          averageServiceTime: "Average Service Time",
          averageWaitingTime: "Average Waiting Time",
          status: "Status (Current)",
          activeTickets: "Active Tickets",
          passiveTickets: "Passive Tickets",
          groups: "Groups",
        },
        users: {
          name: "Name",
          numberAppointments: "Number of Attendances",
          statusNow: "Current Status",
          totalCallsUser: "Total Attendances per User",
          totalAttendances: "Total Attendances",
        },
        date: {
          initialDate: "Start Date",
          finalDate: "End Date",
        },
        licence: {
          available: "Available until",
        },
        assessments: {
          totalCalls: "Total Attendances",
          callsWaitRating: "Attendances Waiting for Rating",
          callsWithoutRating: "Attendances Without Rating",
          ratedCalls: "Rated Attendances",
          evaluationIndex: "Evaluation Index",
          score: "Score",
          prosecutors: "Promoters",
          neutral: "Neutral",
          detractors: "Detractors",
        },
      },
      reports: {
        title: "Research Reports",
        operator: "Operator",
        period: "Period",
        until: "Until",
        date: "Date",
        reportTitle: "Reports",
        calls: "Attendances",
        search: "Surveys",
        durationCalls: "Attendance Duration",
        grupoSessions: "Group Attendances",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generating compressed report, please wait.",
          errorToast: "Error generating report",
          back: "Back",
          groupServiceReport: "Group Attendance Report",
          loading: "Loading...",
          contact: "Contact",
          dateOpen: "Opening Date",
          dateLastUpdated: "Last Update Date",
          agent: "Agent",
          agentClosed: "Agent who closed",
          waitingAssistance: "Waiting for Service",
          process: "In Service",
        },
        researchReports: {
          response: "Response",
          active: "(Active)",
          inactive: "(Inactive)",
          quantity: "Quantity",
          percentage: "Percentage",
          title: "Research Reports",
          activeSearch: "Active Survey",
          inactiveSearch: "Inactive Survey",
        },
        ticketDurationDetail: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Duration Report",
          startService: "Start of Attendance",
          lastUpdated: "Last Updated",
          lastAgent: "Last Agent",
          durationFinished: "Duration After Closing",
        },
        ticketDuration: {
          title: "Attendance Duration Report",
          contact: "Contact",
          open: "Open",
          pending: "Pending",
          finished: "Finished",
          durationFinished: "Duration of Finished Attendances",
          durationAfterFinished: "Duration After Closing",
          actions: "Actions",
        },
        ticketReports: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Report",
        },
        exportExcel: {
          title: "Attendance Reports",
          startDate: "Start date",
          endDate: "End date",
          notInformed: "Not informed",
          columns: {
            id: "ID",
            connection: "Connection",
            contact: "Contact",
            user: "User",
            queue: "Queue",
            status: "Status",
            lastMessage: "Last Message",
            openDate: "Open Date",
            openTime: "Open Time",
            closeDate: "Close Date",
            closeTime: "Close Time",
            supportTime: "Support Time",
            nps: "NPS",
          },
        },
        pdf: {
          title: "List of Completed Attendances",
          exportTitle: "List of Completed Group Attendances",
        },
      },
      todo: {
        newTask: "New Task",
        add: "Add",
        task: "Tasks",
      },
      contactImportWpModal: {
        title: "Export Contacts to Excel",
        buttons: {
          downloadModel: "Download Excel template for import",
          closed: "Close",
          import: "Select Excel file to import Contacts",
        },
      },
      connections: {
        title: "Connections",
        waitConnection: "Please wait... Your connections will be restarted!",
        newConnection: "New Connection",
        restartConnections: "Restart Connections",
        callSupport: "Call Support",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Connect your service channels to receive messages and start conversations with your customers.",
        client: "Client",
        connectedConnections: "Connected connections",
        disconnectedConnections: "Disconnected connections",
        totalConnections: "Total connections",
        total: "Total",
        connections: " Connections:",
        toasts: {
          deleted: "Connection successfully deleted!",
          closedimported:
            "Closing imported tickets, please wait a few moments.",
        },
        confirmationModal: {
          closedImportedTitle: "Close imported tickets",
          closedImportedMessage:
            "If you confirm, all imported tickets will be closed.",
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage:
            "Are you sure? You will need to scan the QR Code again.",
        },
        buttons: {
          add: "Add Connection",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          closedImported: "Close all imported tickets",
          preparing: "Preparing messages for import",
          importing: "Importing WhatsApp Messages",
          processed: "Processed",
          in: "of",
          connecting: "Connecting",
        },
        typography: {
          processed: "Processed",
          in: "of",
          date: "Message Date",
        },
        tooltips: {
          edit: "Edit connection",
          delete: "Delete connection",
          syncTemplates: "Sync templates",
          copyWebhook: "Copy webhook for Meta",
          transferTickets: "Transfer tickets between connections",
          restartConnections: "Restart all connections",
          callSupport: "Call support via WhatsApp",
          newConnection: "Add new connection",
          qrcode: "Show QR Code to connect",
          tryAgain: "Try to reconnect",
          newQr: "Generate new QR Code",
          disconnect: "Disconnect session",
          connecting: "Please wait, connecting...",
          defaultConnection: "This is the default connection",
          channelWhatsapp: "Channel: WhatsApp",
          channelWhatsappOfficial: "Channel: WhatsApp Official (Cloud API)",
          channelFacebook: "Channel: Facebook Messenger",
          channelInstagram: "Channel: Instagram Direct",
          closedImported: "Close all tickets that were imported from history",
          preparing: "Preparing messages for import...",
          importMessages: "Import WhatsApp message history",
        },
        toolTips: {
          opening: {
            title: "Waiting for connection",
            content: "The system is trying to connect. Please wait or click 'New QR Code' to generate a new code.",
          },
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your phone is connected to the internet and try again, or request a new QR Code.",
          },
          qrcode: {
            title: "Waiting for QR Code scan",
            content:
              "Click the 'QR CODE' button and scan the QR Code with your phone to start the session.",
          },
          connected: {
            title: "Disconnect session",
          },
          timeout: {
            title: "Connection with the phone was lost",
            content:
              "Make sure your phone is connected to the internet and WhatsApp is open, or click 'Disconnect' to get a new QR Code.",
          },
          restarting: {
            title: "Restarting connection",
            content: "The connection is being automatically restarted. Please wait a moment...",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          number: "WhatsApp Number",
          color: "Color",
          receiveComments: "Receive Comments",
        },
        receiveComments: {
          enabled: "Comment receiving enabled",
          disabled: "Comment receiving disabled",
          tooltip: {
            enabled: "Comments are being received. Click to disable.",
            disabled: "Comments are not being received. Click to enable.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Existing Attendance",
        },
        form: {
          message: "This contact is already being attended to:",
          user: "Agent",
          queue: "Queue",
          messageWait:
            "This contact is already waiting for service. Check the Waiting tab!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket created.",
          chatBot: "ChatBot started.",
          queue: " - Queue assigned.",
          open: " started the service.",
          access: "accessed the ticket.",
          transfered: "transferred the ticket.",
          receivedTransfer: "received the transferred ticket.",
          pending: "returned to the queue.",
          closed: "closed the ticket.",
          reopen: "reopened the ticket.",
          redirect: "- redirected",
          clientClosed: "Client closed the ticket.",
        },
      },
      whatsappModal: {
        title: {
          add: "Add Connection",
          edit: "Edit Connection",
        },
        tabs: {
          general: "General",
          messages: "Messages",
          assessments: "NPS",
          integrations: "Integrations",
          schedules: "Business Hours",
        },
        form: {
          importOldMessagesEnable: "Import messages from device",
          importOldMessages: "Start date of import",
          importRecentMessages: "End date of import",
          importOldMessagesGroups: "Import group messages",
          closedTicketsPostImported: "Close tickets after import",
          name: "Name",
          queueRedirection: "Queue Redirection",
          queueRedirectionDesc:
            "Select a queue for contacts without an assigned queue",
          default: "Default",
          group: "Allow groups",
          timeSendQueue: "Time in minutes to redirect to queue",
          importAlert:
            "WARNING: Saving will terminate your connection. You will need to scan the QR Code again to import messages.",
          groupAsTicket: "Treat groups as ticket",
          timeCreateNewTicket: "Create a new ticket after X minutes",
          maxUseBotQueues: "Send bot X times",
          maxUseInactiveTime: "Send inactivity flow X times",
          timeUseBotQueues: "Send bot in X minutes",
          timeToReturnQueue: "Time to return to queue in minutes",
          timeAwaitActiveFlow: "Time to wait for active flow",
          expiresTicket: "Close open chats after X minutes",
          expiresTicketNPS: "Close chats awaiting evaluation after X minutes",
          maxUseBotQueuesNPS: "Max times evaluation is sent",
          closeLastMessageOptions1: "From agent/client",
          closeLastMessageOptions2: "From agent only",
          outOfHoursMessage: "Out-of-hours message",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          lgpdLinkPrivacy: "Privacy policy link",
          lgpdMessage: "LGPD greeting message",
          lgpdDeletedMessages: "Obfuscate messages deleted by contact",
          lgpdSendMessage: "Always request contact confirmation",
          ratingMessage: "Evaluation message - Scale must be from 0 to 10",
          token: "Token for external integration",
          sendIdQueue: "Queue",
          inactiveMessage: "Inactivity warning message",
          timeInactiveMessage: "Time in minutes to send inactivity warning",
          flowInactiveTime: "Time in minutes to send inactivity flow",
          whenExpiresTicket: "Close chats when the last message is",
          expiresInactiveMessage: "Inactivity closure message",
          prompt: "Prompt",
          collectiveVacationEnd: "End date",
          collectiveVacationStart: "Start date",
          collectiveVacationMessage: "Collective vacation message",
          queueIdImportMessages: "Queue for message import",
          isOficial: "Official",
          phone_number_id: "Phone Number ID",
          waba_id: "WABA ID",
          send_token: "Sending token",
          business_id: "Business ID",
          phone_number: "Phone number",
          triggerIntegrationOnClose: "Trigger Integration on Ticket Close",
          enableIntegration: "Habilited Integration",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        menuItem: {
          enabled: "Enabled",
          disabled: "Disabled",
          minutes: "minutes",
        },
        success: "Connection saved successfully.",
        errorSendQueue:
          "You set a redirection time but no queue was selected. Both fields are required.",
        errorExpiresNPS: "A timeout must be set for NPS evaluation.",
        errorRatingMessage: "An evaluation message must be provided for NPS.",
      },
      qrCode: {
        title: "Connect WhatsApp",
        message: "Scan the QR Code to start the session",
        waiting: "Waiting for QR Code...",
      },
      contacts: {
        title: "Contacts",
        profileImageTitle: "Profile Photo",
        toasts: {
          deleted: "Contact successfully deleted!",
        },
        searchPlaceholder: "Search...",
        conversationFlows: " Conversation Flows",
        addFlow: "Add Flow",
        editFlow: "Edit Flow ",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import Contacts",
          exportContact: "Export Contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related attendances will be lost.",
          blockContact: "Are you sure you want to block this contact?",
          unblockContact: "Are you sure you want to unblock this contact?",
          importMessage: "Do you want to import all contacts from the phone?",
          importChat: "Import Chats",
          wantImport: "Do you want to import all chats from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
          export: "Export Contact",
        },
        loading: "Loading...",
        loadMore: "Load More",
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
          lastMessage: "Last Message",
        },
        tooltips: {
          sendMessage: "Send message via WhatsApp",
          edit: "Edit contact",
          block: "Block contact",
          unblock: "Unblock contact",
          delete: "Delete contact",
        },
        menu: {
          importYourPhone: "Import from default device",
          importToExcel: "Import/Export from Excel",
          importexport: "IMPORT / EXPORT ",
        },
        fixContactsLid: {
          title: "Fix Contacts (LID)",
          button: "Fix LID",
          tooltip: "Fix duplicate contacts where LID was saved as number",
          start: "Start",
          close: "Close",
          details: "Details",
          steps: {
            idle: "Waiting",
            starting: "Starting",
            identifying: "Identifying contacts",
            finding: "Finding real contacts",
            merging: "Merging contacts",
            completed: "Completed",
            error: "Error",
          },
        },
        importProgress: {
          title: "Import Contacts from Device",
          starting: "Starting import...",
          searching: "Searching contacts on device...",
          importing: "Importing contacts...",
          processing: "Processing",
          of: "of",
          contacts: "contacts",
          completed: "Import completed!",
          created: "contacts created",
          updated: "contacts updated",
          skipped: "skipped",
          error: "Import error",
          closeAndRefresh: "Close and Refresh",
          close: "Close",
        },
      },
      forwardMessage: {
        text: "Forwarded",
      },
      forwardMessageModal: {
        title: "Forward Message",
        buttons: {
          ok: "Forward",
        },
      },
      promptModal: {
        form: {
          name: "Name",
          prompt: "Prompt",
          voice: "Voice",
          max_tokens: "Maximum Tokens in Response",
          temperature: "Temperature",
          apikey: "API Key",
          max_messages: "Maximum Messages in History",
          voiceKey: "Voice API Key",
          voiceRegion: "Voice Region",
        },
        success: "Prompt saved successfully!",
        title: {
          add: "Add Prompt",
          edit: "Edit Prompt",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Name",
          queue: "Sector/Queue",
          max_tokens: "Max Tokens in Response",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone!",
        },
        buttons: {
          add: "Add Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Add Contact",
          edit: "Edit Contact",
        },
        form: {
          mainInfo: "Contact Data",
          extraInfo: "Additional Information",
          name: "Name",
          number: "WhatsApp Number",
          email: "Email",
          extraName: "Field Name",
          extraValue: "Value",
          chatBotContact: "Disable Chatbot",
          termsLGDP: "LGPD Terms accepted on:",
          whatsapp: "Origin Connection:",
        },
        buttons: {
          addExtraInfo: "Add Information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
        walletLinked: "Contact linked to your wallet successfully!",
        walletError: "User has no associated queues",
        saveFirst: "Contact must be saved first",
      },
      wallets: {
        title: "Contact Wallets",
        searchPlaceholder: "Search contacts...",
        filterByUser: "Filter by User",
        allUsers: "All users",
        contact: "Contact",
        user: "User",
        queue: "Queue",
        phone: "Phone",
        email: "Email",
        actions: "Actions",
        editWallet: "Edit Wallet",
        selectUser: "Select User",
        selectQueue: "Select Queue",
        selectUserAndQueue: "Select a user and queue",
        cancel: "Cancel",
        save: "Save",
        confirmDeleteTitle: "Confirm Deletion",
        confirmDeleteMessage:
          "Are you sure you want to remove this contact from the wallet?",
        deleteSuccess: "Contact removed from wallet successfully!",
        updateSuccess: "Wallet updated successfully!",
      },
      queueModal: {
        title: {
          queueData: "Queue Data",
          text: "Business Hours",
          add: "Add Queue",
          edit: "Edit Queue",
          confirmationDelete:
            "Are you sure? All integration options will be deleted.",
        },
        form: {
          name: "Name",
          color: "Color",
          orderQueue: "Queue Order (Bot)",
          rotate: "Rotation",
          timeRotate: "Rotation Time",
          typeRandomMode: "Rotation Type",
          greetingMessage: "Greeting Message",
          complationMessage: "Completion Message",
          outOfHoursMessage: "Out-of-Hours Message",
          token: "Token",
          integrationId: "Integration",
          fileListId: "File List",
          closeTicket: "Close Ticket",
          queueType: "Menu Type",
          message: "Return Message",
          queue: "Transfer Queue",
          integration: "Integration",
          file: "File List",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        bot: {
          title: "Options",
          toolTipTitle: "Add options to build a chatbot",
          toolTip:
            "If there is only one option, it will be automatically chosen, and the bot will respond with the message and proceed",
          selectOption: "Select an Option",
          text: "Text",
          attendent: "Agent",
          queue: "Queue",
          integration: "Integration",
          file: "File",
          toolTipMessageTitle:
            "Message is required to proceed to the next level",
          toolTipMessageContent:
            "Message is required to proceed to the next level",
          selectUser: "Select a User",
          selectQueue: "Select a Queue",
          selectIntegration: "Select an Integration",
          addOptions: "Add Options",
        },
        serviceHours: {
          dayWeek: "Day of the Week",
          startTimeA: "Start Time - Shift A",
          endTimeA: "End Time - Shift A",
          startTimeB: "Start Time - Shift B",
          endTimeB: "End Time - Shift B",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Add Project",
          edit: "Edit Project",
        },
        form: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          jsonContent: "JSON Content",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Expiration time in minutes",
          typebotKeywordFinish: "Keyword to finish the ticket",
          typebotKeywordRestart: "Keyword to restart the flow",
          typebotRestartMessage: "Message when restarting the conversation",
          typebotUnknownMessage: "Invalid option message",
          typebotDelayMessage: "Delay (ms) between messages",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          test: "Test Bot",
        },
        messages: {
          testSuccess: "Integration tested successfully!",
          addSuccess: "Integration added successfully.",
          editSuccess: "Integration edited successfully.",
        },
      },
      userModal: {
        warning: "To import messages, you must scan the QR Code again!",
        title: {
          add: "Add User",
          edit: "Edit User",
          updateImage: "Update Image",
          removeImage: "Delete Image",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          farewellMessage: "Farewell Message",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          whatsapp: "Default Connection",
          allTicketEnable: "Enabled",
          allTicketDisable: "Disabled",
          allTicket: "View Tickets Without Queue",
          allowGroup: "Allow Groups",
          defaultMenuOpen: "Open",
          defaultMenuClosed: "Closed",
          defaultMenu: "Default Menu",
          defaultTheme: "Default Theme",
          defaultThemeDark: "Dark",
          defaultThemeLight: "Light",
          allHistoric: "View Conversations from Other Queues",
          allHistoricEnabled: "Enabled",
          allHistoricDisabled: "Disabled",
          allUserChat: "View Other Users' Conversations",
          userClosePendingTicket: "Allow Closing Pending Tickets",
          showDashboard: "View Dashboard",
          allowRealTime: "View Real-Time Panel",
          allowConnections: "Allow Actions on Connections",
          showContacts: "View Contacts",
          showCampaign: "View Campaigns",
        },
        tabs: {
          general: "General",
          permissions: "Permissions",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addImage: "Add Image",
          editImage: "Edit Image",
        },
        success: "User saved successfully.",
      },
      companyModal: {
        title: {
          add: "Add Company",
          edit: "Edit Company",
        },
        form: {
          name: "Name",
          email: "Email",
          passwordDefault: "Password",
          numberAttendants: "Users",
          numberConections: "Connections",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Company saved successfully.",
      },
      scheduleModal: {
        title: {
          add: "New Schedule",
          edit: "Edit Schedule",
          message: "Message",
        },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          assinar: "Send Signature",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addSchedule: "Add Schedule",
        },
        success: "Schedule saved successfully.",
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
          addKanban: "New Lane",
          editKanban: "Edit Lane",
          backToKanban: "BACK TO KANBAN",
        },
        form: {
          name: "Name",
          color: "Color",
          timeLane: "Time in minutes to redirect to lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Lane Greeting Message",
          mediaFiles: "Media",
          rollbackLaneId: "Return to Lane after resuming attendance",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Tag saved successfully.",
        successKanban: "Lane saved successfully.",
      },
      fileModal: {
        title: {
          add: "Add File List",
          edit: "Edit File List",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
          fileOptions: "Add File",
        },
        form: {
          name: "File List Name",
          message: "List Details",
          fileOptions: "File List",
          extraName: "Message to send with file",
          extraValue: "Option Value",
        },
        success: "File list saved successfully!",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ DRAG AND DROP FILES BELOW ⬇️",
          titleFileList: "File List",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "DO YOU WANT TO CLOSE ALL TICKETS?",
        yes: "YES",
        not: "NO",
        buttons: {
          newTicket: "New",
          resolveAll: "Resolve All",
          close: "Close",
          new: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        inbox: {
          closedAllTickets: "Close all tickets?",
          closedAll: "Close All",
          newTicket: "New Ticket",
          yes: "YES",
          no: "NO",
          open: "Open",
          resolverd: "Resolved",
        },
        toasts: {
          deleted: "The attendance you were handling has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Open" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search attendance and messages",
          filterConections: "Filter by Connection",
          filterConectionsOptions: {
            open: "Open",
            closed: "Closed",
            pending: "Pending",
          },
          filterUsers: "Filter by Users",
          filterContacts: "Filter by Contacts",
          ticketsPerPage: "Tickets per page",
        },
        buttons: {
          showAll: "All",
          returnQueue: "Return to Queue",
          scredule: "Schedule",
          deleteTicket: "Delete Ticket",
        },
        closedTicket: {
          closedMessage: "Close Ticket With Farewell Message",
          closedNotMessage: "Close Ticket Without Farewell Message",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to Queue",
        fieldQueuePlaceholder: "Select a queue",
        fieldWhatsapp: "Select a WhatsApp",
        noOptions: "No users found with that name",
        msgTransfer: "Notes - internal message, will not be sent to the client",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsList: {
        called: "Call",
        today: "Today",
        missedCall: "Missed voice/video call at",
        pendingHeader: "Waiting",
        assignedHeader: "In Attendance",
        allHeader: "All",
        groupingHeader: "Groups",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage:
          "No attendances found with this status or search term",
        noQueue: "No Queue",
        buttons: {
          accept: "Accept",
          cancel: "Cancel",
          start: "Start",
          closed: "Close",
          reopen: "Reopen",
          transfer: "Transfer",
          ignore: "Ignore",
          exportAsPDF: "Export to PDF",
          kanbanActions: "Kanban Options",
        },
        acceptModal: {
          title: "Accept Chat",
          queue: "Select Sector",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      SendContactModal: {
        title: "Send Contact",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Send",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          chatsTempoReal: "Real-Time Panel",
          tickets: "Attendances",
          quickMessages: "Quick Replies",
          contacts: "Contacts",
          wallets: "Wallets",
          queues: "Queues & Chatbot",
          tags: "Tags",
          administration: "Administration",
          companies: "Companies",
          users: "Users",
          birthdaySettings: "Birthday Settings",
          settings: "Settings",
          files: "File Lists",
          helps: "Help Center",
          messagesAPI: "API",
          schedules: "Schedules",
          campaigns: "Campaigns",
          annoucements: "Announcements",
          chats: "Internal Chat",
          chatInternal: "Internal Chat",
          financeiro: "Financial",
          queueIntegration: "Integrations",
          version: "Version",
          kanban: "Kanban",
          prompts: "Talk.AI",
          allConnections: "Manage Connections",
          reports: "Reports",
          management: "Management",
          automations: "Automations",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
            message: "Hello",
            messageEnd: "welcome to",
            active: "Active until",
            goodMorning: "Hi,",
            myName: "my name is",
            continuity: "and I will continue your service.",
            virtualAssistant: "Virtual Assistant",
            token: "Invalid token, please contact the platform administrator.",
          },
          message: {
            location: "Location",
            contact: "Contact",
          },
          notRegister: "No records found",
          refresh: "Refresh",
          tooltips: {
            menu: "Open menu",
            language: "Change language",
            toggleTheme: "Toggle light/dark theme",
            volume: "Volume settings",
            refresh: "Refresh page",
            notifications: "Notifications",
            announcements: "Announcements",
            chat: "Internal chat",
            userMenu: "User menu",
          },
        },
      },
      languages: {
        undefined: "Language",
        "pt-BR": "Portuguese",
        es: "Spanish",
        en: "English",
        tr: "Turkish",
      },
      messagesAPI: {
        title: "API",
        toSend: "TO SEND",
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered Token",
          userId: "User/Agent ID",
          queueId: "Queue ID",
        },
        mediaMessage: {
          number: "Number",
          body: "File Name",
          media: "File",
          token: "Registered Token",
        },
        API: {
          title: "Message Sending Documentation",
          methods: {
            title: "Sending Methods",
            messagesText: "Text Messages",
            messagesMidia: "Media Messages",
          },
          instructions: {
            title: "Instructions",
            comments: "Important Notes",
            comments1:
              "Before sending messages, it is necessary to register the token linked to the connection that will send the messages. <br />To register, access the 'Connections' menu, click the edit button on the connection, and insert the token in the appropriate field.",
            comments2:
              "The sending number must not have a mask or special characters and must be composed of:",
            codeCountry: "Country Code",
            code: "Area Code (DDD)",
            number: "Phone Number",
          },
          text: {
            title: "1. Text Messages",
            instructions:
              "Below is the list of required information to send text messages:",
          },
          media: {
            title: "2. Media Messages",
            instructions:
              "Below is the list of required information to send media messages:",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      quickMessages: {
        title: "Quick Replies",
        searchPlaceholder: "Search...",
        noAttachment: "No attachment",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action is irreversible! Do you want to proceed?",
        },
        buttons: {
          add: "Add",
          attach: "Attach File",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut added successfully!",
          deleted: "Shortcut removed successfully!",
        },
        dialog: {
          title: "Quick Message",
          shortcode: "Shortcut",
          message: "Response",
          save: "Save",
          cancel: "Cancel",
          general: "General",
          geral: "Allow Editing",
          add: "Add",
          edit: "Edit",
          visao: "Allow Viewing",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          actions: "Actions",
          mediaName: "File Name",
          status: "Status",
        },
      },
      contactLists: {
        title: "Contact Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New List",
        },
        dialog: {
          name: "Name",
          company: "Company",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          deleted: "Record deleted successfully.",
          saved: "List saved successfully.",
        },
      },
      contactListItems: {
        title: "Contacts",
        searchPlaceholder: "Search",
        buttons: {
          add: "New",
          lists: "Lists",
          import: "Import",
        },
        dialog: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        table: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
          importMessage:
            "Do you want to import the contacts from this spreadsheet?",
          importTitlte: "Import",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Board",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campaigns",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Listing",
          listContacts: "Contact List",
          settings: "Settings",
        },
        settings: {
          randomInterval: "Random Sending Interval",
          noBreak: "No Interval",
          intervalGapAfter: "Longer interval after",
          undefined: "Undefined",
          messages: "messages",
          laggerTriggerRange: "Larger Sending Interval",
          addVar: "Add Variable",
          save: "Save",
          close: "Close",
          add: "Add",
          shortcut: "Shortcut",
          content: "Content",
        },
        buttons: {
          add: "New Campaign",
          contactLists: "Contact Lists",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          contactList: "Contact List",
          option: "None",
          disabled: "Disabled",
          enabled: "Enabled",
          status: "Status",
          scheduledAt: "Scheduled",
          completedAt: "Completed",
          confirmation: "Confirmation",
          actions: "Actions",
        },
        dialog: {
          new: "New Campaign",
          update: "Edit Campaign",
          readonly: "View Only",
          help: "Use variables like {name}, {number}, {email}, or define custom variables.",
          form: {
            name: "Name",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Confirmation Message 1",
            confirmationMessage2: "Confirmation Message 2",
            confirmationMessage3: "Confirmation Message 3",
            confirmationMessage4: "Confirmation Message 4",
            confirmationMessage5: "Confirmation Message 5",
            messagePlaceholder: "Message content",
            whatsapp: "Connection",
            status: "Status",
            scheduledAt: "Schedule",
            confirmation: "Confirmation",
            contactList: "Contact List",
            tagList: "Tags",
            statusTicket: "Ticket Status",
            openTicketStatus: "Open",
            pendingTicketStatus: "Pending",
            closedTicketStatus: "Closed",
            enabledOpenTicket: "Enabled",
            disabledOpenTicket: "Disabled",
            openTicket: "Open Ticket",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel Sending",
            restart: "Restart Sending",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          pause: "Campaign paused.",
          cancel: "Campaign canceled.",
          restart: "Campaign restarted.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignReport: {
        title: "Campaign Report",
        inactive: "Inactive",
        scheduled: "Scheduled",
        process: "In Progress",
        suspendedConnection: "Suspended by connection",
        cancelled: "Canceled",
        finished: "Completed",
        campaign: "Campaign",
        validContacts: "Valid Contacts",
        confirmationsRequested: "Confirmations Requested",
        confirmations: "Confirmations",
        deliver: "Delivered",
        connection: "Connection",
        contactLists: "Contact List",
        schedule: "Schedule",
        conclusion: "Conclusion",
      },
      announcements: {
        title: "Announcements",
        searchPlaceholder: "Search",
        active: "Active",
        inactive: "Inactive",
        buttons: {
          add: "New Announcement",
          contactLists: "Announcement Lists",
        },
        table: {
          priority: "Priority",
          title: "Title",
          text: "Text",
          mediaName: "File",
          status: "Status",
          actions: "Actions",
        },
        dialog: {
          edit: "Edit Announcement",
          add: "New Announcement",
          update: "Edit Announcement",
          readonly: "View Only",
          form: {
            priority: "Priority",
            title: "Title",
            text: "Text",
            mediaPath: "File",
            status: "Status",
            high: "High",
            medium: "Medium",
            low: "Low",
            active: "Active",
            inactive: "Inactive",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignsConfig: {
        title: "Campaign Settings",
      },
      queues: {
        title: "Queues & Chatbot",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting Message",
          orderQueue: "Queue Order (Bot)",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add Queue",
        },
        toasts: {
          success: "Queue saved successfully.",
          deleted: "Queue deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone! Attendances from this queue will still exist but will no longer be assigned to a queue.",
        },
      },
      queue: {
        queueData: "Queue Data",
      },
      queueSelect: {
        inputLabel: "Queues",
        inputLabelRO: "Read-Only Queues",
        withoutQueue: "No Queue",
      },
      reports: {
        title: "Attendance Reports",
        startDate: "Start date ",
        endDate: "End date",

        table: {
          id: "Ticket",
          user: "User",
          dateOpen: "Opening Date",
          dateClose: "Closing Date",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Connection",
          queue: "Queue",
          actions: "Actions",
          lastMessage: "Last Message",
          contact: "Customer",
          supportTime: "Attendance Time",
        },
        buttons: {
          filter: "Apply Filter",
          onlyRated: "Only Rated",
        },
        searchPlaceholder: "Search...",
      },
      queueIntegration: {
        title: "Integrations",
        table: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          lastUpdate: "Last Update",
          actions: "Actions",
        },
        buttons: {
          add: "Add Project",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone and will be removed from linked queues and connections.",
        },
      },
      users: {
        title: "Users",
        table: {
          status: "Status",
          name: "Name",
          email: "Email",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add User",
        },
        toasts: {
          deleted: "User deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Open tickets for this user will be moved to the queue.",
        },
      },
      compaies: {
        title: "Companies",
        table: {
          ID: "ID",
          status: "Active",
          name: "Name",
          email: "Email",
          password: "Password",
          phone: "Phone",
          plan: "Plan",
          active: "Active",
          numberAttendants: "Agents",
          numberConections: "Connections",
          value: "Value",
          namePlan: "Plan Name",
          numberQueues: "Queues",
          useCampaigns: "Campaigns",
          useExternalApi: "REST API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Internal Chat",
          useSchedules: "Scheduling",
          createdAt: "Created At",
          dueDate: "Expiration Date",
          lastLogin: "Last Login",
          folderSize: "Folder size ",
          totalFiles: " Total Files",
          lastUpdate: "Last update",
          actions: "Actions",
          money: "$",
          yes: "Yes",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrence",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semester: "Semiannual",
          yearly: "Annual",
          clear: "Clear",
          delete: "Delete",
          user: "User",
          save: "Save",
        },
        buttons: {
          add: "Add Company",
        },
        toasts: {
          deleted: "Company deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All company data will be lost. Open tickets for users in this company will be moved to the queue.",
        },
      },
      plans: {
        form: {
          name: "Name",
          users: "Users",
          connections: "Connections",
          campaigns: "Campaigns",
          schedules: "Schedules",
          enabled: "Enabled",
          disabled: "Disabled",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
          yes: "Yes",
          no: "No",
          money: "$",
          public: "Public",
          trial: "Trial",
          trialDays: "Trial Days",
          billingCycle: {
            monthly: "month",
            quarterly: "quarter",
            semiannual: "semiannual",
            annual: "year",
            custom: "custom",
          },
        },
      },
      helps: {
        title: "Help Center",
        settings: {
          codeVideo: "Video Code",
          description: "Description",
          clear: "Clear",
          delete: "Delete",
          save: "Save",
        },
      },
      schedules: {
        title: "Schedules",
        date: "Date",
        time: "Time",
        event: "Event",
        allDay: "All Day",
        week: "Week",
        work_week: "Work Week",
        day: "Day",
        month: "Month",
        previous: "Previous",
        next: "Next",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        today: "Today",
        agenda: "Agenda",
        noEventsInRange: "No events in this range.",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Schedule?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Schedule",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADD COLUMNS",
        search: "SEARCH",
        seeTicket: "SEE TICKET",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          id: "ID",
          name: "Name",
          kanban: "Kanban",
          color: "Color",
          tickets: "Tag Records",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New Tag",
        },
        toasts: {
          deleted: "Tag deleted successfully.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Open",
        backToKanban: "BACK TO KANBAN",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Lane?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tickets",
          actions: "Actions",
        },
        buttons: {
          add: "New Lane",
        },
        toasts: {
          deleted: "Lane deleted successfully.",
        },
      },
      files: {
        title: "File Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Action",
        },
        toasts: {
          deleted: "File list deleted successfully!",
          deletedAll: "All file lists were deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this list?",
          deleteAllMessage: "Are you sure you want to delete all lists?",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        tabs: {
          options: "Options",
          schedules: "Schedules",
          finalization: "Ticket Finalization",
          plans: "Plans",
          helps: "Help",
          companies: "Companies",
          whitelabel: "Whitelabel",
          homepage: "Home Customization",
          masks: "Masks",
          about: "About",
        },
        settings: {
          userCreation: {
            name: "User Creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          tabs: {
            options: "Options",
            schedules: "Schedules",
            plans: "Plans",
            help: "Help",
          },
          sections: {
            general: "General Settings",
            generalDescription: "Configure the main system options",
            messages: "Messages",
            messagesDescription: "Customize automatically sent messages",
            lgpd: "LGPD",
            lgpdDescription: "Privacy and data protection settings",
            payments: "Payments",
            paymentsDescription: "Configure payment methods",
            transcription: "Transcription",
            transcriptionDescription: "Audio transcription settings",
            copyContact: "Contact Copy Configuration",
            copyContactDescription: "Configure how phone numbers are formatted when copying contacts",
          },
          options: {
            disabled: "Disabled",
            enabled: "Enabled",
            updating: "Updating...",
            creationCompanyUser: "Company/User Creation",
            evaluations: "Evaluations",
            officeScheduling: "Office Scheduling",
            queueManagement: "Queue Management",
            companyManagement: "Company Management",
            connectionManagement: "Connection Management",
            sendGreetingAccepted: "Send Greeting on Accepting Ticket",
            sendMsgTransfTicket:
              "Send Transfer Message between Departments/Agents",
            checkMsgIsGroup: "Ignore Group Messages",
            chatBotType: "Bot Type",
            userRandom: "Random Agent Selection",
            buttons: "Buttons",
            acceptCallWhatsapp: "Notify that WhatsApp call is not accepted?",
            sendSignMessage: "Allow agent to choose to send Signature",
            sendGreetingMessageOneQueues:
              "Send Greeting when only one queue exists",
            sendQueuePosition: "Send Queue Position Message",
            sendFarewellWaitingTicket: "Send Farewell Message while Waiting",
            acceptAudioMessageContact:
              "Accept Audio Messages from All Contacts?",
            enableLGPD: "Enable LGPD Processing",
            requiredTag: "Required Tag to Close Ticket",
            closeTicketOnTransfer:
              "Close Ticket when Transferring to Another Queue",
            DirectTicketsToWallets: "Automatically Move Client to Wallet",
            showNotificationPending: "Show Notification for Pending Tickets",
             removeCountryCode: "Remove country code",
            removeAreaCode: "Remove area code (DDD)",
            removeNinthDigit: "Remove ninth digit",
            maskHint: "Type '@' to insert dynamic masks"
          },
          customMessages: {
            sendQueuePositionMessage: "Queue Position Message",
            AcceptCallWhatsappMessage: "Message to Inform Call Not Accepted",
            greetingAcceptedMessage: "Greeting Message When Accepting Ticket",
            transferMessage:
              "Transfer Message - ${queue.name} = destination queue",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Welcome Message (LGPD)",
            linkLGPD: "Privacy Policy Link",
            obfuscateMessageDelete: "Obfuscate Deleted Message",
            alwaysConsent: "Always Request Consent",
            obfuscatePhoneUser: "Obfuscate User Phone Number",
            enabled: "Enabled",
            disabled: "Disabled",
          },
          masks: {
            title: "Mask Reference Guide",
            description: "Use dynamic masks to personalize your messages. Type '@' in message fields to see available options.",
            mask: "Mask",
            description: "Description",
            example: "Example",
            howToUse: "How to use:",
            usageInstructions: "1. When editing a message, type '@' to open the mask menu\n2. Type part of the mask name or description to filter\n3. Click on the desired mask or press Enter to select\n4. The mask will be automatically inserted into the text\n\nExample of complete message:\n\"Hello ${contact.name}! You have been transferred to queue ${queue.name} and will be attended by ${user.name}.\""
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          dialogRatingTitle:
            "Would you like to leave a service rating for the client?",
          dialogClosingTitle: "Closing the service with the client!",
          dialogRatingCancel: "Resolve WITH Farewell Message",
          dialogRatingSuccess: "Resolve and Send Rating",
          dialogRatingWithoutFarewellMsg: "Resolve WITHOUT Farewell Message",
          ratingTitle: "Choose a rating menu",
          notMessage: "No message selected",
          amount: "Prospecting Value",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            rating: "Send Rating",
            enableIntegration: "Enable Integration",
            disableIntegration: "Disable Integration",
            logTicket: "Ticket Logs",
            requiredTag: "You must assign a tag before closing the ticket.",
            greetingAcceptedMessage:
              "You must configure a greeting message when accepting the ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Type a message or press / for quick replies",
        placeholderOpen: "Type a message or press / for quick replies",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        privateMessage: "Private Message",
        cancelForward: "Cancel",
      },
      contactDrawer: {
        header: "Contact Details",
        buttons: {
          edit: "Edit Contact",
          block: "Block",
          unblock: "Unblock",
        },
        extraInfo: "Additional Information",
      },
      messageVariablesPicker: {
        label: "Available Variables",
        vars: {
          contactFirstName: "First Name",
          contactName: "Name",
          user: "Agent",
          greeting: "Greeting",
          protocolNumber: "Protocol Number",
          date: "Date",
          hour: "Hour",
          ticket_id: "Ticket Number",
          queue: "Sector",
          connection: "Connection",
        },
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        delete: "Delete",
        transfer: "Transfer",
        registerAppointment: "Contact Notes",
        resolveWithNoFarewell: "Resolve without Farewell",
        acceptAudioMessage: "Accept audio messages from contact?",
        appointmentsModal: {
          title: "Ticket Notes",
          textarea: "Note",
          placeholder: "Enter the information you want to register here",
        },
        confirmationModal: {
          title: "Delete the contact's ticket",
          titleFrom: "from contact",
          message:
            "Attention! All messages related to this ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Enable/Disable Signature",
          privateMessage: "Enable/Disable Private Message",
          meet: "Send video conference link",
        },
        type: {
          imageVideo: "Photos and Videos",
          cam: "Camera",
          contact: "Contact",
          meet: "Video Call",
          template: "Meta Template",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        edit: "Edit",
        forward: "Forward",
        toForward: "Forward",
        cancelForward: "Cancel",
        talkTo: "Talk To",
        copy: "Copy",
        react: "React",
        favorite: "Favorite",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
      },
      invoices: {
        table: {
          invoices: "Invoices",
          details: "Details",
          users: "Users",
          connections: "Connections",
          queue: "Queues",
          value: "Value",
          expirationDate: "Expiration Date",
          action: "Action",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_SENDING_WAPP_REACTION:
          "Error sending WhatsApp reaction. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_MESSAGE_NOT_FOUND: "Message not found.",
        ERR_INVALID_MESSAGE_DATA: "Error processing message data.",
        ERR_MESSAGE_KEY_NOT_FOUND: "Message key not found.",
        ERR_CONTACT_NOT_FOUND: "Contact not found.",
        ERR_TICKET_NOT_FOUND: "Ticket not found.",
        ERR_EMOJI_REQUIRED: "Emoji is required.",
        ERR_REACTIONS_ONLY_WHATSAPP: "Reactions are only available for WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_OUT_OF_HOURS: "Outside Business Hours!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Method:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (registered token) and Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Message"',
        fieldUserId: '"userId": User ID or ""',
        fieldQueueId: '"queueId": Queue ID or ""',
        fieldSendSignature: '"sendSignature": Sign message - true/false',
        fieldCloseTicket: '"closeTicket": Close the ticket - true/false',
        singMessage: "Sign message - true/false",
        closeTicket: "Close the ticket - true/false",
        testSend: "The Test Send",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Interval filter value",
        sendAsManyTimes: " Send as many times",
        shipNormallyOnNonbusinessDays: "Ship normally on non-business days",
        sendOneBusinessDayBefore: "Send one business day before",
        sendOneBusinessDayLater: "Send one business day later",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
        servicePanel: {
          allowRealTime: "Service Panel",
        },
      },
      servicePanel: {
        allowRealTime: "Service Panel  ",
      },
      financial: {
        invoices: "Invoices",
        details: "Details",
        users: "Users",
        connections: "Connections",
        queues: "Queues",
        value: "Value",
        expirationDate: "Due Date",
        status: "Status",
        action: "Action",
      },
      statusFilter: {
        statusFilter: "Filter by Status",
      },
      momentsUser: {
        services: "Services:",
        pending: "Pending",
        noqueue: "NO QUEUE",
      },
      campaignsPhrase: {
        campaignsFlow: "Campaigns Flow",
        campaigns: "Campaign",
        name: "Name",
        status: "Status",
        newCampaignWithFlowByPhrase: "New campaign with flow by phrase",
        editCampaignWithFlowByPhrase: "Edit campaign with flow by phrase",
        phraseTriggerName: "Phrase trigger name",
        chooseAStream: "Choose a stream",
        whichPhraseTriggersTheFlow: " Which phrase triggers the flow?",
        selectAConnection: " Select a Connection",
        status: " Status",
        cancel: "CANCEL",
        createCampaign: "CREATE CAMPAIGN ",
        saveCampaign: "Sale Campaign",
      },
      chatList: {
        noMessages: "No messages",
        admin: "Admin",
        member: "Member",
        searchChat: "Search chat...",
        createNewChat: "Create new chat",
        searchUser: "Search user...",
        noUserFound: "No user found",
        noUserAvailable: "No user available",
        cancel: "Cancel",
        details: "Details",
        deleteChat: "Delete Chat",
        deleteChatConfirm: "This action cannot be undone, confirm?",
        detailsTitle: "Details",
        edit: "Edit",
        delete: "Delete",
        now: "now",
        minutesAgo: "{{count}}m ago",
        hoursAgo: "{{count}}h ago",
      },
      chatMessages: {
        deleted: "This message was deleted",
        deletedAdmin: "Deleted message - visible only to administrators",
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        editMessage: "Edit Message",
        save: "Save",
        cancel: "Cancel",
        deleteMessage: "Delete Message",
        deleteMessageConfirm: "Are you sure you want to delete this message?",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        doubleClickToReply: "Double click to reply",
        edited: "(edited)",
        forwarded: "(forwarded)",
        typeMessage: "Type a message...",
        send: "Send",
        noMessages: "No messages",
        loading: "Loading...",
        replyingTo: "Replying to",
        clickToGoToOriginal: "Click to go to original message",
      },
      chatPopover: {
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        cancel: "Cancel",
        confirmDelete: "Confirm Delete",
        confirm: "Confirm",
        deleteMessage: "Are you sure you want to delete this message?",
        editMessage: "Edit Message",
        save: "Save",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        noChats: "No chat available",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Groups",
        new: "New",
        messages: "Messages",
        search: "Search...",
        noChats: "No chat found",
        noGroups: "No group found",
        noMessages: "No messages",
        loading: "Loading...",
        error: "Error loading data",
        addGroupPhoto: "Add Group Photo",
        changeGroupPhoto: "Change Group Photo",
        groupName: "Group Name",
        groupDescription: "Group Description",
        save: "Save",
        cancel: "Cancel",
        createGroup: "Create Group",
        editGroup: "Edit Group",
        deleteGroup: "Delete Group",
        deleteGroupConfirm: "Are you sure you want to delete this group?",
        edit: "Edit",
        delete: "Delete",
        details: "Details",
        groupDetails: "Group Details",
        title: "Title",
        description: "Description",
        modal: {
          title: "Create Group",
          editTitle: "Edit Group",
          save: "Save",
          cancel: "Cancel",
          name: "Group Name",
          description: "Group Description",
          create: "Create",
          edit: "Edit",
        },
      },
      whitelabel: {
        primaryColorLight: "Primary Color (Light Theme)",
        primaryColorDark: "Primary Color (Dark Theme)",
        secondaryColorLight: "Secondary Color (Light Theme)",
        secondaryColorDark: "Secondary Color (Dark Theme)",
        useGradient: "Use Gradient",
        useGradientDescription: "Enable gradient effect on visual elements",
        appName: "Application Name",
        logoLight: "Logo (Light Theme)",
        logoDark: "Logo (Dark Theme)",
        favicon: "Favicon",
        backgroundLight: "Background Image (Light Theme)",
        backgroundDark: "Background Image (Dark Theme)",
        preview: "Preview",
        delete: "Delete",
        upload: "Upload",
        availableLanguages: "Available Languages",
        atLeastOneLanguage: "At least one language must be enabled",

        sections: {
          general: "General Settings",
          generalDescription: "Configure the application name and basic information",
          colors: "Colors and Themes",
          colorsDescription: "Customize primary and secondary colors for light and dark themes",
          logos: "Logos and Images",
          logosDescription: "Upload application logos and background images",
          languages: "Available Languages",
          languagesDescription: "Select which languages will be available in the system"
        }
      }
    },
    whatsappModalRel: {
      form: {
        isOficial: "Support Report",
        ticketId: "Ticket ID",
        client: "Customer",
        number: "Number",
        agent: "Agent",
        date: "Date",
        lastMessage: "Last Message",
        fullReport: "The full report is attached above",
        resolveAndTriggerIntegration: "Resolve and Trigger Integration",
        elementNotFoundForExport: "Element not found for export.",
        reportFilename: "support_report",
      },
    },
  },
};

const extraTranslations = {
  common: {
    none: "None",
    yes: "Yes",
    no: "No",
    buttons: {
      save: "Save",
      cancel: "Cancel",
      close: "Close",
      edit: "Edit",
      delete: "Delete",
      create: "Create",
      update: "Update",
      saving: "Saving...",
    },
    status: {
      active: "Active",
      inactive: "Inactive",
      enabled: "Enabled",
      disabled: "Disabled",
    },
    toasts: {
      operationSuccess: "Operation completed successfully!",
    },
  },
  ticketsAdvanced: {
    buttons: { selectTicket: "Select Ticket" },
    tabs: { ticket: "Ticket", attendances: "Attendances" },
  },
  dashboard: {
    title: "Dashboard",
    filterLabels: {
      period: "Period Filter",
      days: "{{count}} days",
      dateRange: "Date Range",
      queues: "Queues",
      attendants: "Agents",
      connections: "Connections",
      channels: "Channels",
    },
    sections: {
      performanceIndicators: "Performance Indicators",
      satisfactionSurvey: "Satisfaction survey",
      hourlyDistribution: "Hourly distribution",
      attendances: "Attendances",
      attendants: "Agents",
    },
    performance: {
      totalAttendances: "Total attendances",
      closed: "Closed",
      open: "Open",
      pending: "Pending",
      withoutQueue: "No Queue Defined",
      withoutUser: "No Agent Defined",
      attendants: "Agents",
      averageServiceTime: "Average Service Time",
      averageWaitingTime: "Average Time Until Start",
      newContacts: "New Contacts",
      details: "Groups: {{groups}} | Private: {{private}}",
    },
  },
  chat: {
    toasts: {
      exists: "A chat with this user already exists!",
      saveError: "Error creating/editing chat",
      loadUsersError: "Error loading users",
      created: "Chat created successfully!",
      createError: "Error creating chat",
    },
    groupPhoto: {
      change: "Change Group Photo",
      add: "Add Group Photo",
    },
    form: {
      title: "Title",
      description: "Description",
      groupDescriptionPlaceholder: "Group description",
    },
    alerts: {
      editWindowExpired: "Messages can only be edited within 10 minutes after sending.",
    },
    modals: {
      editMessage: { title: "Edit Message", message: "Message" },
      forwardMessage: { title: "Forward Message", selectChat: "Select chat", forward: "Forward" },
    },
  },
  contacts: {
    toasts: { blocked: "Contact blocked", unblocked: "Contact unblocked" },
    table: { photo: "Photo", status: "Status" },
    bulk: {
      deleteAllWithCount: "Delete All ({{count}})",
      deleteSelectedWithCount: "Delete Selected ({{count}})",
      delete: "Delete",
      selectedSummary: "{{count}} selected",
      selectedContactsSummary: "{{count}} contact(s) selected",
      allShort: "(ALL)",
      allContacts: "(ALL CONTACTS)",
      deleteAllTooltip: "Delete all contacts",
      deleteSelectedTooltip: "Delete selected contacts",
      deleteSelected: "Delete selected",
      deleteAllContacts: "Delete All Contacts",
      cancelSelection: "Cancel selection",
      selectAllAria: "Select all contacts",
    },
    importProgress: {
      starting: "Starting import...",
      startingImport: "Starting import...",
      importing: "Importing contacts...",
      importError: "Error importing contacts",
      error: "Import error",
      completed: "Import completed!",
      processingGroups: "📁 Processing Groups",
      processingContacts: "👥 Processing Contacts",
      processed: "Processed",
      fetchingWhatsapp: "Fetching WhatsApp data...",
      groupsTitle: "📁 Groups ({{count}})",
      contactsTitle: "👥 Contacts ({{count}})",
      created: "Created",
      updated: "Updated",
      skipped: "Skipped",
      whatsappWebNoSync: "WhatsApp Web does not automatically sync the contact list.",
      contactsCreatedOnMessages: "Contacts are created when you send or receive messages.",
      duration: "Execution time: {{seconds}}s",
    },
  },
  contactDrawer: {
    toasts: {
      checkTicketsError: "Error checking existing tickets",
      startParticipantChatError: "Could not start a conversation with this participant",
      noParticipantsToExport: "There are no participants to export",
      exportSuccess: "File \"{{fileName}}\" exported successfully!",
      exportError: "Error exporting participants",
      blocked: "Contact blocked",
      unblocked: "Contact unblocked",
      updated: "Contact updated successfully!",
    },
    empty: {
      images: "No images found",
      videos: "No videos found",
      audios: "No audio found",
      documents: "No documents found",
      links: "No links found",
    },
    searchPlaceholder: "Search in messages...",
    tabs: {
      info: "Information",
      images: "Images",
      videos: "Videos",
      audios: "Audio",
      documents: "Documents",
      links: "Links",
      participants: "Participants",
    },
    actions: {
      blockContact: "Block contact",
      unblockContact: "Unblock contact",
      export: "Export",
      chat: "Chat",
    },
    warning: { possibleLid: "⚠️ Possible error: Number appears to be LID" },
    participants: { title: "Group Participants ({{count}})" },
    roles: { superAdmin: "Super Admin", admin: "Admin" },
    fallbacks: { otherUser: "Another user", noQueue: "No queue" },
  },
  messageInput: {
    tooltip: {
      signature: "Enable/Disable Signature",
      privateMessage: "Enable/Disable Private Message",
      triggerFlow: "Trigger Flow",
      requiredTemplate: "Send Meta Template (Required)",
      pendingModeSwitch: "Switch: normal / internal message",
      ticketNote: "Ticket note",
    },
    type: { document: "Document", signature: "Signature" },
    format: {
      bold: "Bold",
      italic: "Italic",
      strikethrough: "Strikethrough",
      code: "Code",
      numberedList: "Numbered List",
      bulletList: "Bulleted List",
      quote: "Quote",
      clear: "Clear Formatting",
    },
    pendingAlert: {
      title: "Pending Ticket:",
      description: "Use a normal message to accept and reply, or an internal message/note for internal notes.",
    },
    placeholder: {
      internalMessage: "Internal message (not sent to customer)",
      ticketNote: "Ticket note (internal note)",
    },
    quickAnswers: {
      keyboardHint: "📋 {{count}} replies • use ↑↓ to navigate",
      scrollHint: "{{count}} replies • scroll to see more",
    },
  },
  messagesList: {
    status: { forwarded: "Forwarded", editedAt: "Edited {{time}}" },
    deletedMessage: "🚫 This message was deleted",
    deletedMessageByContact: "🚫 This message was deleted by the contact",
    deletedMessageMarkdown: "🚫 _Message deleted_ ",
    reactions: {
      contactReacted: "{{contact}} reacted... {{reaction}}",
      youReacted: "You reacted... {{reaction}}",
    },
  },
  campaigns: {
    filters: {
      status: "Filter by Status",
      recurrence: "Filter by Recurrence",
      all: "All",
      allFemale: "All",
      recurring: "Recurring",
      single: "Single",
    },
    status: {
      inactive: "Inactive",
      scheduled: "Scheduled",
      inProgress: "In Progress",
      suspendedConnection: "Suspended by connection - manual resume",
      cancelled: "Cancelled",
      finished: "Finished",
    },
    operationalStatus: {
      paused: "Paused",
      scheduled: "Scheduled",
      cancelled: "Cancelled",
      failed: "Failed",
      suspendedManual: "Suspended - awaiting manual resume",
      completed: "Completed",
      running: "Running",
      pending: "Pending",
    },
    recurrence: {
      minutely: "Minutely",
      hourly: "Hourly",
      daily: "Daily",
      weekly: "Weekly",
      biweekly: "Biweekly",
      monthly: "Monthly",
      yearly: "Yearly",
      executions: "{{count}} executions",
      single: "Single",
      finished: "Recurrence finished",
    },
    table: { recurrence: "Recurrence", nextExecution: "Next Execution" },
    toasts: {
      noPermissionRedirect: "This company does not have permission to access this page! Redirecting.",
      stopRecurrence: "Recurrence stopped successfully!",
    },
    confirmationModal: {
      stopRecurrenceTitle: "Stop Recurrence",
      stopRecurrenceMessage: "Are you sure you want to stop this campaign recurrence? The current campaign will continue running, but there will be no future executions.",
    },
    tooltips: {
      recurringCampaign: "Recurring Campaign",
      suspendedConnection: "The campaign was suspended due to a disconnection and will not resume automatically after reconnecting.",
      pauseCampaign: "Pause Campaign",
      resumeCampaign: "Resume Campaign",
      resumeCampaignManually: "Resume Campaign Manually",
      stopRecurrence: "Stop Recurrence",
      report: "Report",
    },
    fallbacks: {
      removedList: "Removed list",
      notDefined: "Not defined",
      removedWhatsapp: "Removed WhatsApp",
      noSchedule: "No schedule",
      notCompleted: "Not completed",
    },
    pagination: {
      total: "Total: {{count}} campaigns",
      rowsPerPage: "Rows per page:",
      displayedRows: "{{from}}-{{to}} of {{count}}",
      moreThan: "more than {{to}}",
    },
    dialog: {
      form: { variablesHelper: "💡 Type @ to insert dynamic variables (e.g. {{name}}, {{contactNumber}}, {{contactEmail}})" },
      validation: {
        tooShort: "Too short!",
        tooLong: "Too long!",
        required: "Required",
        connectionRequired: "Connection is required",
        recurrenceTypeRequired: "Recurrence type is required",
        intervalGreaterThanZero: "Interval must be greater than 0",
        intervalRequired: "Interval is required",
        weekDayRequired: "Select at least one weekday",
      },
      recurrence: {
        title: "Recurrence Configuration",
        enable: "Enable recurrence",
        type: "Recurrence Type",
        interval: "Interval",
        intervalHelper: "Every {{interval}} {{unit}}",
        weekDays: "Weekdays",
        dayOfMonth: "Day of Month",
        dayOfMonthHelper: "Specific day of the month (1-31)",
        endDate: "End Date (optional)",
        maxExecutions: "Maximum Executions (optional)",
        infiniteHelper: "Leave empty for infinite recurrence",
        hideNextExecutions: "Hide Next Executions",
        showNextExecutions: "View Next Executions",
        nextFiveExecutions: "Next 5 Executions:",
        executionNumber: "Execution {{count}}",
        units: {
          minutes: "minute(s)",
          hours: "hour(s)",
          days: "day(s)",
          weeks: "week(s)",
          biweeks: "biweek(s)",
          months: "month(s)",
          years: "year(s)",
        },
      },
      messageTab: "Msg. {{count}}",
    },
  },
  campaignsPhrase: {
    toasts: {
      loadFlowsError: "Error loading flows",
      loadConnectionsError: "Error loading connections",
      loadCampaignError: "Error loading campaign data",
      requiredFields: "Please fill in all required fields",
      flowNotFound: "Selected flow not found",
      updated: "Campaign updated successfully!",
      created: "Campaign created successfully!",
      saveError: "Error saving campaign",
    },
    form: {
      campaignName: "Campaign name",
      nameRequired: "Name is required",
      selectFlow: "Select a flow",
      flowRequired: "Flow is required",
      multiple: "(Multiple)",
      whatsappConnections: "WhatsApp Connections",
      connectionRequired: "At least one connection must be selected",
      selectedConnections: "{{count}} connection(s) selected:",
      selectedConnectionsDescription: "The campaign will run when any of these connections receive messages matching the configured phrases.",
      phrasesTitle: "Phrases/Words that trigger the flow",
      exactMatchTitle: "Exact Match:",
      exactMatchDescription: "The message must be identical to the configured phrase.",
      partialMatchTitle: "Partial Match:",
      partialMatchDescription: "The phrase may be contained anywhere in the message.",
      phraseLabel: "Phrase {{count}}",
      phrasePlaceholder: "Type the phrase or keyword",
      phraseRequired: "Phrase is required",
      type: "Type",
      exact: "Exact",
      partial: "Partial",
      addPhrase: "Add Phrase",
    },
  },
  flowBuilder: {
    title: "Conversation Flows ({{count}})",
    searchPlaceholder: "Search flows...",
    toasts: {
      activated: "Flow activated successfully",
      deactivated: "Flow deactivated successfully",
      deleted: "Flow deleted successfully",
      duplicated: "Flow duplicated successfully",
      selectZip: "Please select a ZIP file (.zip)",
      imported: "Flow imported successfully",
    },
    editor: {
      title: "Flow Editor",
      addNodes: "Add Nodes",
      saveFlow: "Save Flow",
      toasts: { saved: "Flow saved successfully", saveError: "Error saving flow" },
    },
  },
  floup: {
    title: "Follow UP - Flow Templates",
    stepsCount: "{{count}} steps",
    buttons: { newTemplate: "New Template", duplicate: "Duplicate", saveTemplate: "Save Template", addStep: "Add Step" },
    dialog: { editTitle: "Edit Template", newTitle: "New Template" },
    sections: { basicInfo: "Basic Information", triggerCondition: "Trigger Condition", stopControls: "Flow Stop Controls", flowSteps: "Flow Steps" },
    descriptions: { triggerCondition: "Define when this Follow UP should be activated. Once activated, all steps will run sequentially until stop conditions are met." },
    form: { templateName: "Template Name", templateType: "Template Type", description: "Description", condition: "Condition", selectQueue: "Select queue", selectTag: "Select tag", conditionDescription: "Condition description", conditionPlaceholder: "Ex: Customer sent first message" },
    templateTypes: { client: "Customer", lead: "Lead", custom: "Custom" },
    conditions: { queue: "System queue", tag: "System tag", firstClientInteraction: "First customer interaction", firstAttendantInteraction: "First agent interaction" },
    delete: { title: "Confirm Deletion", message: "Are you sure you want to delete Follow UP", warning: "This action cannot be undone and all associated media will be permanently deleted." },
  },
  connections: { toasts: { loadError: "Could not load the record list" } },
  settings: { toasts: { schedulesUpdated: "Schedules updated successfully." } },
  companies: {
    form: { contactEmail: "Contact Email *", adminEmail: "Administrator Email *", timezone: "Timezone", recurrence: "Recurrence", generateInvoice: "Generate Invoice" },
    toasts: { loadError: "Could not load the record list", operationError: "Could not complete the operation. Check whether a company with the same name already exists or whether the fields were filled correctly", deleteError: "Could not complete the operation" },
    confirmation: { deleteTitle: "Delete Record", deleteMessage: "Do you really want to delete this record?" },
  },
};

const mergeTranslations = (target, source) => {
  Object.keys(source).forEach((key) => {
    if (
      source[key] &&
      typeof source[key] === "object" &&
      !Array.isArray(source[key])
    ) {
      target[key] = target[key] || {};
      mergeTranslations(target[key], source[key]);
      return;
    }
    target[key] = source[key];
  });
};

mergeTranslations(messages.en.translations, extraTranslations);
mergeTranslations(messages.en.translations, {
  dashboard: { toasts: { loadError: "Error loading dashboard data" } },
  contactDrawer: { toasts: { loadParticipantsError: "Error loading group participants" } },
  messagesList: {
    video: {
      unsupported: "Your browser does not support video playback.",
      loadError: "❌ Error loading video",
    },
  },
  messageInput: {
    flowProcessingAlert: {
      title: "Flow Running:",
      description: "Message field temporarily disabled.",
    },
    templateRequiredAlert: {
      title: "24h Window Expired:",
      description: "To resume the conversation, send a Meta template first.",
    },
  },
  floup: {
    alerts: {
      saveError: "Error saving Follow UP. Check the console for more details.",
      deleteError: "Error deleting Follow UP. Check the console for more details.",
    },
  },
});
mergeTranslations(messages.en.translations, {
  common: { statusLabel: "Status", labels: { all: "All" } },
  salesReport: {
    title: "Sales Report",
    toasts: { selectPeriod: "Please select the period" },
    filters: { startDate: "Start Date", endDate: "End Date", agent: "Agent", noSaleReason: "No Sale Reason", finishReason: "Closing Reason" },
    buttons: { generate: "Generate Report", generating: "Generating..." },
    stats: { totalSales: "Total Sales", totalSalesValue: "Total Sales Value", noSales: "No Sales", averageTicketsByAgent: "Average Tickets per Agent" },
    sections: { noSaleReasons: "No Sale Reasons", finishedTickets: "Finished Tickets", agentPerformance: "Performance by Agent" },
    table: { agent: "Agent", date: "Date", saleValue: "Sale Value", noSaleReason: "No Sale Reason", finishReason: "Closing Reason", totalSales: "Total Sales", totalSalesValue: "Total Sales Value", noSales: "No Sales", totalTickets: "Total Tickets", averageTickets: "Average Tickets" },
  },
  schedules: {
    toasts: { sentEditBlocked: "This schedule has already been sent and cannot be edited.", sentDeleteBlocked: "A schedule that has already been sent cannot be deleted.", noPermissionRedirect: "This company does not have permission to access this page! Redirecting." },
    confirmations: { deleteSchedule: "Do you want to delete this schedule?" },
    aria: { calendarView: "calendar view", monthView: "month view", weekView: "week view", dayView: "day view", agendaView: "agenda" },
  },
  home: {
    themeToggle: "Toggle theme",
    aria: { openMenu: "Open menu", dashboardMockup: "Dashboard mockup" },
    nav: { features: "Features", integrations: "Integrations", plans: "Plans", contact: "Contact", login: "Log in", startNow: "Start Now" },
    hero: { badge: "Omnichannel SaaS for Support and Sales", title: "Automate your support and scale your sales with TicketWhats", description: "Centralize WhatsApp, Instagram and Facebook in a modern platform with AI, smart campaigns and advanced automations.", startFree: "Start for Free", viewDemo: "View Demo" },
    stats: { uptime: "Uptime", messages: "Messages", support: "Support", integrations: "Integrations" },
    dashboard: { title: "TicketWhats Dashboard", activeTickets: "Active tickets", campaignsToday: "Campaigns today", customerMessage: "Customer: Hi, I need support", botMessage: "AI Bot: I connected you to the right department.", agentMessage: "Agent: Perfect, I will help you now." },
    floating: { conversion: "+42% Conversion", aiActive: "AI Active", apiOnline: "API Online" },
    features: { title: "Features for high-performance teams", description: "A complete stack for support, automation and growth with a premium experience.", empty: "No features registered yet. Configure plan features in the admin panel." },
    integrations: { title: "Integrations that speed up your operation", description: "Connect your channels, automations and data without friction.", empty: "No integrations registered yet. Showing default integrations." },
    ai: { title: "Automation with Artificial Intelligence", description: "Automatic replies, smart routing, contextual campaigns and hybrid support to increase efficiency without losing quality.", items: { contextReplies: "Quick replies with customer context", priorityRouting: "Automatic triage and distribution by priority", smartWorkflows: "Smart workflows with human fallback", realtimeInsights: "Operational insights with real-time metrics" }, panelTitle: "AI Assistant", sampleUser: "Customer: I want to know about the Business plan", sampleBotOne: "AI: I can show pricing, features and schedule a demo now.", sampleBotTwo: "AI: Would you like to receive the proposal by WhatsApp or email?" },
    pricing: { title: "Plans for every growth stage", description: "Choose the ideal plan and evolve without switching platforms.", loading: "Loading plans...", featured: "Most Chosen", empty: "No active public plan found in the database." },
    cta: { title: "Ready to transform your support?", description: "Activate TicketWhats and operate with more speed, intelligence and predictability.", viewPlatform: "View Platform" },
    footer: { description: "Premium platform for omnichannel support, automation and revenue growth.", product: "Product", company: "Company", support: "Support", createAccount: "Create account", docs: "Documentation", api: "API", terms: "Terms", copyright: "© {{year}} TicketWhats. All rights reserved." },
  },
  campaignReport: {
    toasts: { noPermissionRedirect: "This company does not have permission to access this page! Redirecting.", shippingLoadError: "Error loading shipping data" },
    shippingStatus: { delivered: "Delivered", processing: "Processing", pending: "Pending", sent: "Sent", read: "Read", played: "Played", failedRetryable: "Failed, retrying", failed: "Failed", cancelled: "Cancelled" },
    whatsappConnection: "WhatsApp Connection",
    usedTag: "Used Tag",
    notSpecified: "Not specified",
    notScheduled: "Not scheduled",
    notCompleted: "Not completed",
    messageDetails: "Message Details",
    exportExcel: "Export Excel",
    messagesTableAria: "messages table",
    loading: "Loading...",
    noMessagesFound: "No messages found",
    table: { recipient: "Recipient", message: "Message", sentAt: "Sent at", deliveredAt: "Delivered at", attemptsNextRetry: "Attempts / Next Retry" },
  },
  messageModal: {
    attachedFile: "Attached file: {{fileName}}",
    form: { name: "Name", intervalValue: "Interval Value", sendHowManyTimes: "How many times to send", showUser: "Show User", createTicket: "Create Ticket" },
    placeholders: { connection: "Connection", contacts: "Contacts", users: "Users" },
    options: { sendNormallyOnNonBusinessDays: "Send normally on non-business days", sendOneBusinessDayBefore: "Send one business day before", sendOneBusinessDayAfter: "Send one business day after" },
  },
  flowBuilderInputModal: {
    question: { title: "Question", tooltip: ["The question that will be sent to the user. You can include variables using $", "{variableName}"].join(""), label: "Type the question", placeholder: ["Ex: Hi $", "{name}, how old are you?"].join("") },
    variables: { available: "Available variables (click to insert):" },
    variableName: { title: "Variable name", tooltip: "Variable name where the answer will be stored. Do not use spaces or special characters.", label: "Variable name", placeholder: "Ex: customer_age", helper: "The user's answer will be stored in this variable" },
    howItWorks: { title: "How it works", description: "This node will send the question to the user and wait for an answer. When the user replies, the value will be stored in the specified variable and the flow will continue to the next node." },
  },
  helpsManager: {
    form: { title: "Title" },
    table: { aria: "helps table", title: "Title", video: "Video" },
    toasts: { loadError: "Could not load the record list", operationError: "Could not complete the operation. Check whether help with the same name already exists or whether the fields were filled correctly", deleteError: "Could not complete the operation" },
    confirmation: { deleteTitle: "Delete Record", deleteMessage: "Do you really want to delete this record?" },
  },
});

mergeTranslations(messages.en.translations, {
  common: {
    note: "Note",
    noData: "No data",
    buttons: { save: "Save", cancel: "Cancel", update: "Update", search: "Search", loadMore: "Load more..." },
    status: { error: "Error", inactive: "Inactive", online: "Online", offline: "Offline", connected: "Connected", disconnected: "Disconnected" },
    loading: { searching: "Searching..." },
  },
  connections: {
    contactsImport: {
      title: "Import WhatsApp Contacts?",
      message: "We found {{count}} contacts on WhatsApp. Do you want to import them into the system?",
      note: "The import may take a few minutes depending on the number of contacts. You can track progress on the Contacts page.",
      later: "Not Now",
      confirm: "Yes, Import",
    },
    transfer: {
      title: "Ticket Transfer",
      source: "Source",
      target: "Destination",
      descriptionStart: "To transfer tickets, select the",
      descriptionMiddle: "connection (where tickets will be moved from) and the",
      descriptionEnd: "connection (where tickets will be transferred to). All active attendances from the source connection will be moved to the destination connection.",
    },
    table: { channel: "Channel" },
    aria: { syncTemplates: "Sync templates", copyWebhook: "Copy webhook" },
  },
  contacts: {
    group: "Group",
    importFileTitle: "Import contacts from file",
    bulk: { selectContactAria: "Select contact {{name}}" },
  },
  signup: {
    document: {
      label: "CPF or CNPJ",
      helper: "Enter CPF (11 digits) or CNPJ (14 digits)",
      cpfValid: "Valid CPF!",
      cpfInvalid: "Invalid CPF!",
      cnpjValidCompanyFilled: "Valid CNPJ! Company name filled automatically.",
      invalidOrNotFound: "Invalid document or not found in Receita Federal",
      validationError: "Error validating document. Try again.",
    },
  },
  wallets: { notFound: "Wallet not found" },
  invoices: { table: { status: "Status" } },
  financial: {
    attention: "Attention",
    expiredSubscription: "Your subscription is expired. Contact support to regularize your situation.",
  },
  helps: { youtubePlayerTitle: "YouTube video player" },
  tickets: {
    globalSearch: {
      title: "Global Search in attendance",
      results: "{{count}} result(s)",
      minChars: "Type at least 2 characters to search contacts, tickets, and messages.",
      noResults: "No results found for this search.",
      placeholder: "Search contacts, tickets, and messages",
    },
    search: { filterAria: "Filter" },
  },
  newTicketModal: {
    newAttendance: "New Attendance",
    attendanceSector: "Attendance Sector",
    sendChannel: "Sending Channel",
    selectSector: "Select the sector...",
    selectConnection: "Select the connection...",
    otherUser: "Another user",
    errors: { selectQueue: "Select a queue" },
  },
  contactListItemFromContactsModal: {
    title: "Search in contact list",
    searchPlaceholder: "Search by name or number...",
    selectedOne: "contact selected",
    selectedMany: "contacts selected",
    noContactsFound: "No contact found",
    noContactsAvailable: "No contact available",
    add: "Add",
    adding: "Adding...",
  },
  messageModal: { placeholders: { tags: "Tags" } },
  messageInput: {
    audioMessage: "🎧 Audio message",
    aria: {
      clearReply: "Clear reply",
      sendTemplateRequired: "Send required template",
      emojiPicker: "Open emoji picker",
      uploadMedias: "Attach media",
      uploadMediaFile: "Attach photo or video",
      uploadDocument: "Attach document",
      toggleSignature: "Toggle signature",
      triggerFlow: "Trigger flow",
      pendingModeSwitch: "Toggle pending attendance mode",
      pendingModeNote: "Use ticket note",
      cancelForward: "Cancel forwarding",
      sendMessage: "Send message",
      cancelRecording: "Cancel recording",
      sendRecordedAudio: "Send recorded audio",
      showRecorder: "Open recorder",
      privateMessage: "Toggle private message",
      scheduleMessage: "Schedule message",
    },
  },
  floupDashboard: {
    title: "Follow UP Dashboard by Steps",
    followUp: "Follow UP",
    nextRun: "Next",
    recentError: "⚠️ Recent error",
    step: "Step",
    steps: "Steps",
    contacts: "Contacts",
    channel: "Channel",
    noMessage: "No message",
    emptyStepContacts: "No contacts in this step",
    selectFloup: "Select a Floup to view the steps",
    noData: "No data found for this Floup",
    noSteps: "No steps found",
  },
});

mergeTranslations(messages.en.translations, {
  common: {
    yes: "Yes",
    no: "No",
    words: { and: "and" },
    time: { seconds: "seconds" },
    buttons: {
      previous: "Previous",
      next: "Next",
      save: "Save",
      refresh: "Refresh",
      cancel: "Cancel",
    },
  },
  globalSearch: {
    title: "Global Search",
    subtitle: "Find contacts, conversation snippets, and tickets in one place.",
    loading: "Searching contacts, messages, and tickets...",
    placeholders: {
      all: "Search contacts, messages, and tickets",
      messages: "Search by words, phrases, or conversation snippets",
      tickets: "Search by ticket, contact, number, or last message",
      contacts: "Search by contact name, number, or email",
    },
    fallbacks: {
      noName: "No name",
      contact: "Contact",
      noContact: "No contact",
      noTextMessage: "[message without text]",
      noQueue: "No queue",
      notAssigned: "Unassigned",
      noLastMessage: "No last message",
    },
    meta: {
      company: "Company",
      tickets: "Tickets",
      lastInteraction: "Last interaction",
      status: "Status",
      queue: "Queue",
      responsible: "Responsible",
    },
    hints: {
      openConversation: "Click to open the conversation",
      openContact: "Click to open the contact",
      openMessage: "Click to open directly in the message",
      openTicket: "Click to open the ticket",
    },
    empty: {
      title: "Smart global search",
      minChars: "Type at least 2 characters to search the whole database.",
      noGlobalResults: "No results found in global search.",
      noTabResults: "No results found in this tab.",
    },
    types: { contact: "Contact", message: "Message", ticket: "Ticket" },
    results: { combined: "{{count}} combined result(s) across the three categories" },
    pagination: { page: "Page", results: "{{count}} result(s)" },
    tabs: { all: "All", contacts: "Contacts", messages: "Messages", tickets: "Tickets" },
  },
  campaignsWarmup: {
    title: "Campaign Warmup Control Center",
    subtitle: "Dense operational view by connection, with capacity, reputation, events, history, and administrative actions directly on the main screen.",
    toasts: {
      actionSuccess: "Action completed successfully!",
      blockReasonRequired: "Enter the block reason.",
      connectionBlocked: "Connection administratively blocked.",
    },
    stages: {
      blocked: "Level 0 · Blocked",
      new: "Level 1 · New",
      initial: "Level 2 · Initial",
      moderate: "Level 3 · Moderate",
      conservative: "Level 4 · Conservative",
      normal: "Level 5 · Normal",
      high: "Level 6 · High",
    },
    status: {
      blocked: "Blocked",
      awaitingBaseline: "Awaiting baseline",
      healthy: "Healthy",
      attention: "Attention",
      critical: "Critical",
      campaignsReleased: "Campaigns released",
    },
    labels: {
      manualBlock: "Manual block",
      automaticBlock: "Automatic block",
      number: "Number",
      connections: "Connections",
      sentToday: "Sent today",
      blockReason: "Block reason",
    },
    fallbacks: {
      campaign: "Campaign #{{id}}",
    },
    meta: {
      status: "Status",
      lastSend: "Last send",
      lastStageChange: "Last stage change",
    },
    empty: {
      noData: "No data",
      noStage: "No stage",
      noBaseline: "No baseline",
      noOperationalBaseline: "No operational baseline",
      noCampaignBaseline: "No campaign baseline yet",
      noAction: "No action",
      noRecentHistory: "No recent history.",
      noActiveCampaigns: "No active campaigns.",
      noCriticalRecommendations: "No critical recommendations right now.",
      awaitingCampaignData: "Waiting for campaign data to generate recommendations.",
      noConnectionFound: "No connection found",
      noConnectionDescription: "When there are connections with campaign warmup, they will appear here with a complete operational view.",
    },
    metrics: {
      healthScore: "Health Score",
      spamRiskScore: "Spam Risk Score",
      dailyLimitVsSent: "Daily limit vs sent today",
      hourlyLimitVsSent: "Hourly limit vs sent this hour",
      deliveryRate: "Delivery Rate",
      readRate: "Read Rate",
      replyRate: "Reply Rate",
      deliveredToday: "Delivered Today",
      readToday: "Read Today",
      repliesToday: "Replies Today",
      positiveReplies: "Positive replies",
      negativeReplies: "Negative replies",
      neutralReplies: "Neutral replies",
      optOuts: "Opt-outs",
      averageReplyTime: "Average reply time",
      percentConsumed: "{{percent}}% consumed",
      successes: "Successes",
      failures: "Failures",
      invalid: "Invalid",
      score: "Score",
    },
    sections: {
      connectionCapacity: "Connection capacity",
      reputationVolume: "Reputation and volume",
      dayEvents: "Day events",
      periodPerformance: "Performance by period",
      recommendations: "Recommendations",
      recentHistory: "Recent history",
      activeCampaigns: "Active campaigns",
      analytics: "Analytics view",
    },
    tabs: { today: "Today", sevenDays: "7 days", thirtyDays: "30 days" },
    hints: { lowerIsBetter: "Lower is better" },
    alerts: {
      manualBlockActive: "Manual block active",
      automaticBlockActive: "Automatic block active",
      blockedUntil: "Blocked until {{date}}.",
      noBlockDetails: "No block details.",
    },
    actions: {
      promote: "Promote",
      regress: "Regress",
      block: "Block",
      unblock: "Unblock",
      resetCounters: "Reset counters",
      confirmBlock: "Confirm block",
    },
    kpis: {
      totalConnections: "Total connections",
      monitoredNow: "Monitored now",
      healthy: "Healthy",
      highScoreLowRisk: "High score and low risk",
      atRisk: "At risk",
      needReview: "Need operational review",
      blocked: "Blocked",
      manualOrAutomatic: "Manual or automatic",
      consumedCapacity: "Consumed capacity",
      averageSpamRisk: "Average Spam Risk",
    },
    analytics: {
      healthy: "Healthy",
      blocked: "Blocked",
      summary: "Quick health, distribution, and consumption summary for executive reading.",
      hide: "Hide analytics",
      show: "Show analytics",
      dailyConsumption: "Daily consumption by connection",
      operationalHealth: "Operational health",
      stageDistribution: "Distribution by stage",
      quickIndicators: "Quick indicators",
    },
    indicators: {
      noConnection: "No connection found to monitor.",
      withoutBaseline: "{{count}} connection(s) still do not have enough baseline for health assessment.",
      risky: "{{count}} connection(s) require attention due to low health score or high spam risk.",
      blocked: "{{count}} connection(s) are blocked and require review before scaling volume.",
      nearLimit: "{{count}} connection(s) have already consumed more than 80% of daily capacity.",
      stable: "Operation is stable right now. No critical alert detected.",
    },
    dialog: {
      blockConnectionTitle: "Block connection for campaigns",
      blockConnectionDescription: "Enter the administrative block reason. This justification will be recorded for operational audit.",
    },
  },
  callHistoricals: {
    title: "Call History",
    searchPlaceholder: "Search by name or phone...",
    empty: "No records found",
    stats: {
      total: "Total Calls",
      rejected: "Rejected Calls",
      served: "Answered Calls",
      finished: "Finished Calls",
    },
    columns: {
      name: "Name",
      phone: "Phone",
      agent: "Agent",
      dateTime: "Date/Time",
      direction: "Direction",
      status: "Status",
      duration: "Duration",
      type: "Type",
      recording: "Recording",
      actions: "Actions",
    },
    status: {
      ended: "Finished",
      active: "Active",
      ringing: "Ringing",
      busy: "Busy",
      noAnswer: "Not Answered",
      rejected: "Rejected",
    },
    direction: { outgoing: "Outgoing", incoming: "Incoming" },
    fallbacks: { receivedCall: "Received Call" },
    tooltips: { downloadAudio: "Download audio", makeCall: "Make call" },
  },
  campaignsConfig: {
    toasts: {
      noPermissionRedirect: "This company does not have permission to access this page! We are redirecting you.",
      saved: "Settings saved",
    },
    sections: { intervals: "Intervals" },
  },
  floup: {
    step: {
      title: "Step {{order}}",
      emptyMessage: "Empty message",
      attachment: "Attachment",
      message: "Message",
      characterCount: "{{count}}/500 characters",
      value: "Value",
      timeUnit: "Time Unit",
      sendAfter: "Send after {{value}} {{unit}}",
      attachmentLink: "Attachment/Link",
      urlPlaceholder: "Paste the URL here",
      removeLink: "Remove link",
      removeMedia: "Remove media",
      removeStep: "Remove Step",
      chooseFile: "Choose File",
      videoUnsupported: "Your browser does not support the video element.",
    },
    timeUnits: { minutes: "Minutes", hours: "Hours", days: "Days", weeks: "Weeks", months: "Months", years: "Years" },
    mediaTypes: { link: "Link", upload: "Upload" },
    preview: { title: "Message Preview", attachmentHint: "Attachment icon will appear here" },
    alerts: { uploadError: "Error uploading the file. Check the console for more details." },
    stopConditions: {
      anyMessage: "1. If the Contact replies to any message",
      keyword: "2. If the Contact replies with a keyword",
      keywordLabel: "Keyword",
      keywordPlaceholder: "Ex: STOP, CANCEL, EXIT",
      ticketClosed: "3. If the Ticket is Closed",
    },
  },
  flowDefault: {
    title: "Default flow",
    toasts: { deleted: "Flow deleted successfully", updated: "Default flows updated" },
    deleteConfirmation: "Are you sure you want to delete this flow? All related integrations will be lost.",
    selectFlowPlaceholder: "Choose a flow",
    welcomeFlow: {
      title: "Welcome flow",
      description: "This flow is triggered only for new contacts, people who are not in your contact list and sent a message",
    },
    defaultResponseFlow: {
      title: "Default response flow",
      description: "Default Response is sent with any character different from a keyword. ATTENTION! It will be triggered if the service is already closed and 6 hours have passed since it was closed.",
    },
  },
  subscription: {
    title: "Subscription",
    licensePeriod: "License Period",
    licenseDueToday: "Your license expires today!",
    licenseDueDays: "Your license expires in {{days}} days!",
    billingEmail: "Billing email",
    subscribeNow: "Subscribe Now!",
  },
  messagesApi: {
    toasts: {
      noPermissionRedirect: "This company does not have permission to access this page! We are redirecting you.",
      messageSent: "Message sent successfully",
    },
    buttons: { send: "Send" },
    docs: {
      endpoint: "Endpoint",
      method: "Method",
      headers: "Headers",
      registeredToken: "registered token",
      formData: "FormData",
      userIdHint: "User ID or",
      queueIdHint: "Queue ID or",
      file: "file",
    },
  },
});

mergeTranslations(messages.en.translations, {
  common: {
    loading: {
      saving: "Saving...",
    },
    buttons: {
      add: "Add",
      edit: "Edit",
      remove: "Remove",
      close: "Close",
      saveChanges: "Save changes",
    },
  },
  flowBuilder: {
    nodes: {
      media: {
        unsupportedHtml5: "Your browser does not support HTML5",
      },
      audio: { title: "Audio", recorded: "Recorded live", sent: "Audio sent" },
      video: { title: "Video" },
      message: { title: "Message" },
      attendant: { title: "Agent" },
      removeTag: { title: "Remove Tag" },
      switchFlow: { title: "Switch Flow" },
      question: { title: "Question" },
      interval: { title: "Interval" },
      randomizer: { title: "Randomizer" },
      tag: { title: "Tag" },
      menu: { title: "Menu" },
      ticket: { title: "Queue" },
      image: { title: "Image" },
      openAi: { assistant: "GPT AI Assistant" },
      gemini: { assistant: "Google AI Assistant" },
      input: {
        responseVariable: "Variable to store response:",
        valueTooltip: "Value: {{value}}",
        variableNotDefined: "Variable not defined",
        usingVariables: "Using variables: {{variables}}",
        alwaysAsk: "Always ask (even if the variable already exists)",
      },
      variable: {
        title: "Global Variable",
        name: "Variable name",
        value: "Value",
        helper: "You can use static values or references like " + String.fromCharCode(36) + "{otherVariable}",
        saved: "Saved!",
        saveButton: "Save variable",
        savedSuccess: "Variable saved successfully!",
      },
      httpRequest: {
        presetsTitle: "Preconfigured Webhooks",
        selectPreset: "Select preset",
        selectPresetPlaceholder: "Choose a ready configuration...",
        systemPreset: "SYSTEM",
        usingPreset: "Using preset:",
        urlFromPreset: "URL (from preset)",
        urlPlaceholder: "https://api.example.com/webhook",
        urlHelper: "You can edit the preset base URL if necessary",
        method: "Method",
        testRequest: "Test Request",
        apiResponse: "API response:",
        viewFullResponse: "View full response",
        hideAdvanced: "Hide advanced",
        showAdvanced: "Show advanced",
        advancedWarning: "Advanced settings can override preset settings",
        timeoutMs: "Timeout (ms)",
        queryParams: "Query Parameters",
        key: "Key",
        value: "Value",
        addParam: "Add Parameter",
        headersJson: "Headers (JSON)",
        headersPlaceholder: "{\"Authorization\": \"Bearer token\", \"Custom-Header\": \"XYZ\"}",
        requestBodyJson: "Request body (JSON)",
        editRequestBody: "Edit request body",
        hideMapping: "Hide Response Variables",
        mapResponseVariables: "Map Response Variables",
        mapResponseData: "Map response data to variables",
        path: "Path",
        pathPlaceholder: "ex: data.user.id",
        variableName: "Variable name",
        variablePlaceholder: "ex: userId",
        addVariable: "Add variable",
        usefulTips: "Useful tips:",
        apiResponseTip: "• The full API response is automatically saved in the global variable",
        variableUsageTip: "You can use " + String.fromCharCode(36) + "{variableName} in the URL and request body to include variable values.",
        fullApiResponse: "Full API response",
        toasts: { presetError: "Error applying preset configuration" },
      },
    },
    modals: {
      singleBlock: {
        addTitle: "Add content to flow",
        addMenuTitle: "Add menu to flow",
        editTitle: "Edit content",
        variables: "Variables",
        toasts: {
          emptyMessage: "Message fields are empty!",
          invalidInterval: "Interval cannot be 0 or greater than 120!",
          contentAdded: "Content added successfully!",
          deleteEmptyCards: "Delete empty cards (Image, Audio and Video)",
        },
      },
      media: {
        image: "Image",
        audio: "Audio",
        video: "Video",
        text: "Text",
        interval: "Interval",
        document: "Document",
        message: "Message",
        timeInSeconds: "Time in seconds",
        uploadImage: "Upload image",
        uploadAudio: "Upload audio",
        uploadVideo: "Upload video",
        uploadDocument: "Upload Document",
        sendAsRecordedAudio: "Send as audio recorded live",
        viewDocument: "View Document",
        addAudioTitle: "Add audio to flow",
        editAudioTitle: "Edit audio",
        addImageTitle: "Add image to flow",
        editImageTitle: "Edit image",
        addVideoTitle: "Add video to flow",
        editVideoTitle: "Edit video",
        toasts: {
          audioAdded: "Audio added successfully!",
          imageAdded: "Image added successfully!",
          videoAdded: "Video added successfully!",
        },
        errors: {
          fileTooLarge2mb: "File is too large! 2MB maximum",
          fileTooLarge5mb: "File is too large! 5MB maximum",
          fileTooLarge10mb: "File is too large! 10MB maximum",
          fileTooLarge20mb: "File is too large! 20MB maximum",
        },
      },
      randomizer: {
        addTitle: "Add a randomizer to flow",
        editTitle: "Edit randomizer",
        percentageAria: "Percentage",
        errors: {
          addIntervalValue: "Add the interval value",
          maxTimeReached: "Maximum time reached: 120 seconds",
        },
      },
      conditionCompare: {
        newTitle: "New Comparison",
        editTitle: "Edit Comparison",
        value1: "Value 1",
        value2: "Value 2",
        valueHelper: "Can be fixed text or a variable (ex: " + String.fromCharCode(36) + "{variable})",
        value1Tooltip: "This is the value that will be compared. It can be fixed text or a variable.",
        value2Tooltip: "This is the value the first value will be compared with. It can be fixed text or a variable.",
        valuePlaceholder: "Type a value or select a variable",
        operator: "Comparison Operator",
        variableButton: "Variable",
        selectVariable: "Select Variable",
        variableHelp: "These are example variables. Configure real variables in the Global Variable node or other flow nodes.",
        searchVariable: "Search variable...",
        configureVariableNode: "(Configure in the Global Variable node)",
        noVariables: "No variables found",
        categories: { contact: "Contact", message: "Message" },
        variables: {
          contactName: "Contact name",
          contactEmail: "Contact email",
          contactPhone: "Contact phone",
          lastMessage: "Last received message",
          lastContactDate: "Last contact date",
          apiResponse: "Last HTTP request response",
        },
        errors: {
          firstRequired: "The first value is required",
          secondRequired: "The second value is required for this operator",
        },
        operators: {
          equals: "Equals",
          notEquals: "Different from",
          contains: "Contains",
          greaterThan: "Greater than",
          lessThan: "Less than",
          greaterOrEqual: "Greater than or equal to",
          lessOrEqual: "Less than or equal to",
          startsWith: "Starts with",
          endsWith: "Ends with",
          isEmpty: "Is empty",
          isNotEmpty: "Is not empty",
        },
      },
      openAi: {
        addTitle: "Add OpenAI to flow",
        editTitle: "Edit OpenAI in flow",
        basicSettings: "Basic Settings - OpenAI",
        apiKey: "OpenAI API Key",
        model: "OpenAI Model",
        voiceSettings: "Voice Settings (Optional)",
        responseType: "Response Type",
        voiceKey: "Voice Key (Azure)",
        voiceKeyPlaceholder: "Azure Speech Service key",
        voiceRegion: "Voice Region (Azure)",
        voiceRegionPlaceholder: "ex: brazilsouth",
        behaviorTooltip: "Configure how OpenAI should behave in the flow",
        validation: {
          voiceKeyRequired: "Voice Key is required for speech synthesis",
          voiceRegionRequired: "Voice Region is required for speech synthesis",
        },
      },
      gemini: {
        addTitle: "Add Gemini to flow",
        editTitle: "Edit Gemini in flow",
        basicSettings: "Basic Settings - Google Gemini",
        apiKey: "Google AI API Key",
        model: "Gemini Model",
        behaviorTooltip: "Configure how Gemini should behave in the flow",
      },
      ai: {
        assistantName: "Assistant Name",
        systemPrompt: "System Prompt",
        systemPromptPlaceholder: "Describe how the AI should behave, what information it should collect, and how it should respond...",
        temperature: "Temperature",
        temperatureHelper: "0 = conservative, 2 = creative",
        maxTokens: "Max Tokens",
        maxTokensHelper: "Maximum response size",
        maxMessages: "Max Messages",
        maxMessagesHelper: "Context history",
        flowBehavior: "Flow Behavior",
        flowMode: "Operating Mode",
        permanent: "Permanent",
        endFlowHere: "End flow here",
        permanentDescription: "The user keeps talking to the AI until they request transfer or end",
        temporary: "Temporary",
        returnToFlow: "Returns to the flow later",
        temporaryDescription: "The AI performs a specific task and then returns to the normal flow",
        temporarySettings: "⏱️ Temporary Mode Settings",
        temporarySettingsDescription: "Configure when the AI should stop and return to the flow",
        maxInteractions: "Maximum Interactions",
        maxInteractionsHelper: "Maximum number of messages before returning to the flow (0 = unlimited)",
        timeoutMinutes: "Timeout (minutes)",
        timeoutHelper: "Time limit before returning to the flow (0 = no limit)",
        continueKeywords: "Keywords to Continue Flow",
        keywordPlaceholder: "Type a keyword",
        continueKeywordsHelper: "When the user sends one of these words, the flow will continue automatically",
        objective: "AI Objective",
        objectiveHelper: "Describe what the AI should complete (ex: 'Collect name, email and phone')",
        objectivePlaceholder: "Ex: Collect customer data, Qualify interest, Diagnose problem...",
        autoComplete: "Auto complete when objective is reached",
        autoCompleteHelper: "The AI will automatically analyze whether it completed the objective and return to the flow",
        transferQueueId: "Queue ID (for transfer)",
        transferQueueIdHelper: "Queue ID to transfer to if the user requests an agent (0 = do not transfer)",
        validation: {
          invalidModel: "Invalid model",
          objectiveRequired: "Objective is required when auto complete is active",
        },
      },
    },
  },
});

mergeTranslations(messages.en.translations, {
  common: {
    title: "Title",
    name: "Name",
    description: "Description",
    actions: "Actions",
    settings: { general: "General Settings" },
    buttons: { add: "Add", back: "Back" },
    toasts: { operationUpdated: "Operation updated successfully." },
  },
  settings: {
    components: {
      about: {
        subtitle: "WhatsApp Service System",
        systemVersions: "System Versions",
        checkUpdates: "Check updates",
        systemStatus: "System Status",
        refreshInfo: "Refresh information",
        online: "Online",
        memoryUsage: "Memory in Use",
        platform: "Platform",
        availableFeatures: "Available Features",
        footer: "Built to improve customer service",
        companyId: "Company ID",
        user: "User",
        toasts: {
          whatsappUpdated: "WhatsApp version updated: {{version}}",
          whatsappAlreadyUpdated: "WhatsApp version is already up to date",
          adminOnly: "Only administrators can check for updates",
          checkError: "Error checking for updates",
        },
        features: {
          multichannel: "Multichannel service via WhatsApp",
          tickets: "Ticket and queue management",
          chatbot: "Chatbot with automated flows",
          campaigns: "Campaigns and bulk messages",
          reports: "Reports and dashboards",
          apis: "External API integration",
          agents: "Multiple agent support",
          schedules: "Message scheduling",
        },
      },
      companyTimezone: {
        title: "Company timezone",
        description: "Business hours, automations and schedules use this timezone as reference.",
        timezone: "Timezone",
        saveTimezone: "Save timezone",
        toasts: {
          companyDataError: "Could not load the complete company data.",
          updateSuccess: "Company timezone updated successfully.",
        },
      },
      finalizacaoAtendimento: {
        title: "Service Finalization",
        informSaleValue: "Ask for sale value when finalizing service",
        informSaleValueHelp: "When enabled, the sale value field will appear in the finalization modal",
        reasonsTitle: "Finalization Reasons",
        addReason: "Add Reason",
        editReason: "Edit Reason",
        reasonName: "Reason Name",
        reasonDescription: "Description (optional)",
        noDescription: "No description",
        emptyReasons: "No reasons registered. Click \"Add Reason\" to start.",
        confirmDelete: "Are you sure you want to delete this reason?",
        toasts: {
          reasonNameRequired: "Reason name is required",
          reasonUpdated: "Reason updated successfully!",
          reasonCreated: "Reason created successfully!",
          reasonSaveError: "Error saving reason",
          reasonDeleted: "Reason deleted successfully!",
          reasonDeleteError: "Error deleting reason",
          configUpdated: "Configuration updated successfully!",
          configUpdateError: "Error updating configuration",
        },
      },
      homePageCustomization: {
        loading: "Loading settings...",
        colorCustomization: "Color Customization",
        primaryColor: "Primary Color",
        backgroundColor: "Background Color",
        textColor: "Text Color",
        accentColor: "Accent Color",
        fontCustomization: "Font Customization",
        fontFamily: "Font Family",
        fontSize: "Font Size (px)",
        contentCustomization: "Content Customization",
        heroSection: "Hero Section (Main)",
        badgeText: "Badge Text",
        mainTitle: "Main Title",
        featuresSection: "Features Section",
        pricingSection: "Pricing Section",
        ctaSection: "Call to Action Section (CTA)",
        saveAll: "Save All Settings",
        toasts: {
          saveSuccess: "Configuration saved successfully!",
          saveError: "Error saving configuration",
          saveAllSuccess: "All settings were saved successfully!",
          saveSettingsError: "Error saving settings",
        },
      },
      infoMp: {
        title: "Mercado Pago Integration",
        intro: "To start integrating your system with Mercado Pago, follow these simple steps:",
        steps: {
          createAccount: "Create an account in Mercado Pago Developers",
          createApp: "Create an application in Mercado Pago Developers",
          productionCredentials: "Click Production > Production credentials",
          copyApiKey: "Click copy and then paste the key into API key",
          webhooks: "In Mercado Pago, click notifications > webhooks",
          productionUrl: "In production mode, paste the following URL \"{{url}}\" and check payments under Events",
        },
      },
      options: {
        textMessageType: "Text",
        automaticPositionNotifications: "Automatic Position Notifications",
        minimumIntervalMinutes: "Minimum Interval (minutes)",
        minimumPositionDifference: "Minimum Position Difference",
        specialPositionMessage: "Special Message (Position 1)",
        specialPositionPlaceholder: "You are next in line!",
        queuePositionHelper: "Type @ to insert dynamic variables (ex: {{name}}, {{position}}, {{queue}})",
        copyContactTab: "Contact Copy Prefix Configuration",
        removeCountryCode: "Remove country code?",
        removeAreaCode: "Remove area code?",
        removeNinthDigit: "Remove ninth digit?",
        nameMsHelper: "Type @ to insert dynamic variables (ex: {{name}}, {{ms}})",
        nameQueueMsHelper: "Type @ to insert dynamic variables (ex: {{name}}, {{queue}}, {{ms}})",
        nameUserMsHelper: "Type @ to insert dynamic variables (ex: {{name}}, {{userName}}, {{ms}})",
      },
      uploaderCert: {
        certificateTab: "Efí Certificate - PIX API (p12)",
        chooseOption: "Choose an option:",
        chooseCertificate: "Choose Efí p12 PIX API Certificate",
        sendCertificate: "SEND CERTIFICATE",
        toasts: {
          noPermission: "No permission to access!",
          p12Only: "Use only p12 files!",
          chooseFile: "Choose a file!",
          chooseDestination: "Choose a destination!",
          uploadSuccess: "File uploaded successfully!",
        },
      },
    },
  },
  birthdaySettings: {
    title: "Birthday Settings",
    loading: "Loading settings...",
    preview: "Preview:",
    userBirthdays: "User Birthdays",
    enableUserNotifications: "Enable user birthday notifications",
    enableUserNotificationsHelp: "When enabled, a congratulations modal will be shown and an automatic announcement will be created",
    createUserAnnouncement: "Create automatic announcement for user birthdays",
    createUserAnnouncementHelp: "Creates an automatic announcement shown to all company users",
    userMessage: "Birthday message for users",
    userMessageHelper: "Type @ to insert dynamic variables (ex: {{name}}, {{userName}})",
    contactBirthdays: "Contact Birthdays",
    enableContactMessages: "Enable automatic birthday messages for contacts",
    enableContactMessagesHelp: "Automatically sends congratulations by WhatsApp to birthday contacts",
    contactMessage: "Birthday message for contacts",
    contactMessageHelper: "Type @ to insert dynamic variables (ex: {{name}}, {{firstName}})",
    testMessage: "Test Message",
    sendTime: "Message sending time",
    sendTimeHelper: "Time when automatic messages will be sent",
    whatsappConnection: "WhatsApp Connection for Sending",
    selectConnection: "Select a connection",
    whatsappConnectionHelp: "WhatsApp connection used to send birthday messages",
    createInternalAnnouncement: "Create internal announcement for user birthdays",
    createInternalAnnouncementHelp: "Creates an internal announcement when a user has a birthday",
    availableVariables: "Available variables in messages:",
    personName: "Person name",
    personAgeContactsOnly: "Person age (contacts only)",
    saveSettings: "Save Settings",
    prompts: { testContactId: "Enter the ID of a contact for testing:" },
    toasts: {
      loadError: "Error loading birthday settings",
      saveSuccess: "Birthday settings saved successfully!",
      saveError: "Error saving settings",
      testSent: "Test message sent!",
      testError: "Error sending test message",
    },
  },
  birthdayModal: {
    title: "Congratulations!",
    subtitle: "Today is a special day!",
    loading: "Loading birthdays...",
    you: "You!",
    systemUser: "System User",
    contact: "Contact",
    ageOne: "{{count}} year",
    ageOther: "{{count}} years",
    sending: "Sending...",
    messageAlreadySent: "Message already sent",
    sendCongrats: "Send Congratulations",
    remindLater: "Remind me later",
    gotIt: "Got it, thanks!",
    toasts: {
      loadError: "Error loading birthdays",
      messageSent: "Congratulations message sent to {{name}}!",
      alreadySent: "Birthday message has already been sent today to this contact",
      sendError: "Error sending birthday message",
    },
  },
  scheduleModal: {
    errors: {
      alreadySentReadonly: "This schedule has already been sent and cannot be changed.",
      validContactRequired: "Select a valid contact for the schedule.",
    },
    titles: { sendError: "Send Error", messageStatus: "Message {{status}}", group: "Group" },
    readonlyNotice: "This schedule has already been sent and can no longer be changed.",
    form: {
      contact: "Contact",
      bodyHelper: "Type @ to insert dynamic variables (ex: {{name}}, {{dataAgendamento}}, {{ms}})",
      quickMessageSearch: "Type to search quick replies...",
      noQuickMessages: "No quick replies found",
    },
    reminder: {
      title: "Reminder (Optional)",
      description: "Set a reminder date. The message will be sent at the reminder time instead of the original schedule time",
      date: "Reminder Date",
      sameMessage: "The reminder message will be the same as the scheduled message.",
    },
    quickMessageAttachment: "From Quick Reply",
  },
  finalizacaoVendaModal: {
    title: "Service Finalization - Sale Value",
    loadingSettings: "Loading settings...",
    saleCompletedQuestion: "Was the sale completed?",
    saleCompletedYes: "Yes, sale completed",
    saleCompletedNo: "No, sale not completed",
    saleValue: "Sale Value (R$)",
    noSaleReason: "No Sale Reason *",
    finalizationReason: "Finalization Reason *",
    selectReason: "Select a reason",
    finishing: "Finalizing...",
    finishService: "Finalize Service",
    errors: {
      saleValueRequired: "Please enter the sale value.",
      noSaleReasonRequired: "Please select the no sale reason.",
      finalizationReasonRequired: "Please select the finalization reason.",
    },
  },
  contactImport: {
    fields: { name: "Name", number: "Number", birthDate: "Birth Date", wallet: "Wallet" },
    validateContacts: "Validate contacts on WhatsApp",
    importingWait: "Importing... Please wait",
    importContacts: "Import contacts",
    importResult: "Import result",
    contactsCreated: "{{count}} contacts created successfully",
    contactsIgnored: "{{count}} contacts ignored (invalid number or not selected for update)",
    importMore: "Import more contacts",
    processingFile: "Processing file...",
    invalidFileTitle: "Invalid file!",
    invalidFileDescription: "The file you tried to import is not valid. Please try again with a file in the correct format.",
    tryAgain: "Try again",
    uploadAlt: "Upload",
    dropExcel: "Click or drag an Excel file",
    acceptedFormats: "* Accepted formats: xls, xlsx, csv, txt",
    requiredColumnsHelp: "To import contacts, you must have at least name and phone number columns.",
    errors: {
      numberFieldRequired: "The contact number field was not selected",
      nameFieldRequired: "The contact name field was not selected",
      noContactsSelected: "No contact selected",
      fieldAlreadySelected: "The field {{field}} has already been selected.",
    },
    toasts: {
      importSuccess: "Import completed successfully! {{count}} contacts imported.",
      importWithIgnored: "Import completed: {{imported}} contacts imported and {{ignored}} ignored.",
      importFailed: "Import failed. No contacts were imported.",
    },
  },
  plansManager: {
    queues: "Queues",
    amount: "Amount",
    internalChat: "Internal Chat",
    externalApi: "External API",
    integrations: "Integrations",
    tableAria: "plans table",
    deleteTitle: "Record Deletion",
    deleteMessage: "Do you really want to delete this record?",
    toasts: {
      loadError: "Could not load the records list",
      operationValidationError: "Could not perform the operation. Check whether a plan with the same name already exists or whether the fields were filled correctly",
      operationError: "Could not perform the operation",
    },
  },
  companiesManager: { tableAria: "companies table" },
  quickMessageDialog: {
    official: "Official",
    messageHelper: "Type @ to insert dynamic variables (ex: {{name}}, {{userName}}, {{ms}})",
    attachMedia: "Attach Media",
    editMedia: "Edit media",
    removeMedia: "Remove media",
    newFile: "New File",
    newRecordedAudio: "New recorded audio",
    newAudio: "New Audio",
    chooseReplacementMedia: "Choose new media to replace:",
    chooseMediaOption: "Choose an option to attach media:",
    attachFile: "Attach File",
    recordAudio: "Record Audio",
    cancelEdit: "Cancel Edit",
    type: "Type",
    value: "Value",
  },
  whatsAppModal: {
    toasts: { clickSaveToRegister: "Click save to register the changes" },
    tabs: { chatbot: "Chatbot", defaultFlow: "Default Flow" },
    variableHelperNameMs: "Type @ to insert dynamic variables (ex: {{name}}, {{ms}})",
    welcomeFlowTitle: "Welcome flow",
    welcomeFlowDescription: "This flow is triggered only for new contacts, people who are not in your contact list and sent a message",
  },
});

mergeTranslations(messages.en.translations, {
  chatMessages: {
    loadingOlderMessages: "Loading older messages...",
    doubleClickToReply: "Double click to reply",
    userFallback: "User",
    cancelRecording: "Cancel recording",
    sendRecordedAudio: "Send recorded audio",
    cancelUpload: "Cancel upload",
    sendUpload: "Send upload",
    emojiPicker: "Select emoji",
    showRecorder: "Show recorder",
    upload: "Upload file",
    messageFallback: "Message",
    audioMessage: "Audio message",
    messageNotFound: "[message not found]",
  },
  cameraModal: {
    previewAlt: "Preview",
    retakePhoto: "Take another photo",
    confirmPhoto: "Confirm photo",
    capturePhoto: "Capture photo",
    errors: {
      access: "Could not access the camera.",
      notFound: "No camera found on this device. Please use the attach image option to send a photo.",
      permissionDenied: "Camera permission denied. Please allow camera access in your browser settings.",
      inUse: "The camera is being used by another application. Close other applications that may be using the camera.",
      unsupported: "The camera settings are not supported. Try using another device.",
      accessWithDetails: "Could not access the camera: {{details}}",
    },
  },
  modalImageCors: {
    image: "Image",
    downloadImage: "Download image",
    sentAt: "Sent at {{date}}",
    receivedAt: "Received at {{date}}",
    imageZoom: "Image zoom",
  },
  pdfPreview: {
    loadError: "Error loading file",
    downloadFile: "Download file",
    clickToDownload: "Click to download",
  },
  audioRecorder: {
    microphoneAccessError: "Error accessing the microphone. Check permissions.",
    recordAudio: "Record Audio",
    recording: "Recording...",
    recordedAudio: "Recorded audio",
    confirmOrDelete: "Click confirm to confirm or delete to remove",
  },
  filters: {
    connections: "Select connections",
    contacts: "Contacts",
    tags: "Filter by Tags",
    channels: "Select channels",
    queues: "Select queues",
    users: "Select agents",
  },
});

mergeTranslations(messages.en.translations, {
  kanban: {
    toasts: {
      ticketTagUpdated: "Ticket Tag updated successfully!",
      ticketTagRemoved: "Ticket Tag removed!",
      adminOnlyReorder: "Only administrators can reorder Kanban lanes",
      lanesOrderUpdated: "Lane order updated successfully",
      lanesOrderSaveError: "Error saving lane order",
    },
    sort: {
      label: "Sort by",
      ticketNumber: "Ticket Number",
      lastMessage: "Last Message",
      valueDesc: "Value (highest to lowest)",
      startDate: "Start date",
      endDate: "End date",
    },
    card: {
      ticketNumber: "Ticket #{{id}}",
      valueWithAmount: "Value: R$ {{amount}}",
      assignValue: "Assign Value",
      remove: "Remove",
      viewTicket: "View Ticket",
      editOpportunityValue: "Edit Opportunity Value",
      assignOpportunityValue: "Assign Opportunity Value",
      value: "Value",
    },
  },
  contactModal: {
    placeholders: {
      email: "Email address",
    },
    form: {
      lid: "LID (Linked Device ID)",
      jid: "JID (WhatsApp ID)",
      birthDate: "Birth Date",
    },
    helpers: {
      lid: "Linked device identifier",
      jid: "Full WhatsApp identifier (JID)",
      birthDate: "Birth date for automatic birthday messages",
      noFloup: "This contact is not in any Floup at the moment",
    },
    floup: {
      currentStep: "{{name}} - Step {{current}} of {{total}}",
      nextRun: "Next execution: {{date}}",
      active: "Active Floup",
      noneActive: "No active Floup",
    },
  },
  queueModal: {
    toasts: {
      clickSaveToRegister: "Click save to register the changes",
    },
    tabsAria: "Queue settings tabs",
    minutes: {
      one: "1 minute",
      two: "2 minutes",
      three: "3 minutes",
      four: "4 minutes",
      five: "5 minutes",
      ten: "10 minutes",
      fifteen: "15 minutes",
      thirty: "30 minutes",
      fortyFive: "45 minutes",
      sixty: "60 minutes",
    },
    randomMode: {
      random: "Random",
      ordered: "Ordered",
    },
    form: {
      selectRandomMode: "Select the rotation type",
    },
  },
  userModal: {
    form: {
      birthDate: "Birth Date",
      birthDateHelper: "Birth date for birthday notifications",
      saleFinalization: "Finalization with Sale Value",
      enabled: "Enabled",
      disabled: "Disabled",
    },
    status: {
      unknown: "Unknown",
      online: "Online",
      offline: "Offline",
    },
  },
  notifications: {
    openNotifications: "Open notifications",
  },
});

mergeTranslations(messages.en.translations, {
  campaignsPhrase: {
    title: "Flow Campaigns",
    buttons: {
      new: "New Campaign",
    },
    columns: {
      name: "Name",
      connections: "Connections",
      status: "Status",
    },
    toasts: {
      deleted: "Campaign deleted successfully",
    },
    tooltips: {
      edit: "Edit campaign",
      delete: "Delete campaign",
    },
    empty: {
      title: "No campaign found",
      description: "Click \"New Campaign\" to create your first flow campaign",
    },
    fallbacks: {
      noName: "No name defined",
    },
    noConnection: "No connection",
    moreConnections: "{{count}} more connection(s)",
    configuredPhrases: "{{count}} configured phrase(s)",
  },
  dashboard: {
    toasts: {
      ticketInfoError: "Error fetching ticket information",
    },
    heatmap: {
      title: "Attendance Heatmap",
      description: "Number of attendances started by weekday and hour.",
      hourRange: "{{start}}:00 to {{end}}:59",
      attendances: "{{count}} attendance(s)",
      ticketDetails: "Ticket #{{ticketId}} | Contact: {{contact}} | Number: {{number}} | Status: {{status}} | Agent: {{user}}",
      ticketMeta: "Number: {{number}} | Status: {{status}} | Agent: {{user}}",
      additionalTickets: "+ {{count}} additional ticket(s)",
      peak: "Peak in period: {{count}} attendance(s) started in one hour.",
      lower: "Lower",
      higher: "Higher",
      dialogTitle: "{{day}} | {{hourRange}} | {{count}} attendance(s)",
      noName: "No name",
      shortDays: {
        sunday: "Sun",
        monday: "Mon",
        tuesday: "Tue",
        wednesday: "Wed",
        thursday: "Thu",
        friday: "Fri",
        saturday: "Sat",
      },
      days: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
      },
    },
  },
  users: {
    table: {
      avatar: "Avatar",
    },
    toasts: {
      chatCreated: "Chat created successfully!",
      chatsGenerated: "Chats generated successfully!",
    },
    confirmations: {
      backfillChats: "Are you sure you want to generate chats for all existing users? This may take a while and create many chats.",
    },
  },
  signup: {
    form: {
      plan: "Plan",
    },
  },
  prompts: {
    toasts: {
      noPermissionRedirect: "This company does not have permission to access this page! We are redirecting you.",
    },
  },
  announcements: {
    toasts: {
      noPermissionRedirect: "This company does not have permission to access this page! We are redirecting you.",
    },
  },
  companies: {
    toasts: {
      noPermissionRedirect: "This company does not have permission to access this page! We are redirecting you.",
    },
  },
  queueIntegration: {
    toasts: {
      noPermissionRedirect: "This company does not have permission to access this page! We are redirecting you.",
    },
  },
});

mergeTranslations(messages.en.translations, {
  common: {
    understood: "Got it",
    noName: "No name",
    error: "Error",
    table: {
      actions: "Actions",
    },
  },
  contactListItems: {
    toasts: {
      bulkDeleted: "{{count}} contacts deleted successfully!",
      bulkDeleteError: "Error deleting contacts",
    },
    confirmationModal: {
      downloadExample: "Click here to download the example spreadsheet.",
      deleteSelectedTitle: "Delete {{count}} selected contacts?",
      deleteSelectedMessage: "Are you sure you want to delete the selected contacts? This action cannot be undone.",
    },
    bulk: {
      pageSelected: "All {{count}} contacts on this page were selected.",
      selectAllList: "Select all {{count}} contacts in this list",
      allSelected: "All {{count}} contacts in this list are selected.",
      clearSelection: "Clear selection",
    },
    table: {
      photo: "Photo",
    },
    tooltips: {
      whatsappValid: "Valid WhatsApp",
      whatsappInvalid: "Invalid WhatsApp",
    },
    importProgress: {
      importing: "Importing contacts ({{percent}}%)",
      total: "Total in spreadsheet: {{count}}",
      toImport: "Will be imported: {{count}}",
      processed: "Processed: {{count}}",
      imported: "Imported: {{count}}",
      existing: "Already existing: {{count}}",
      duplicated: "Duplicates: {{count}}",
      errors: "With error: {{count}}",
      existingTitle: "Contacts already existing in the list:",
      duplicatedTitle: "Duplicate contacts detected:",
      errorTitle: "Contacts with error:",
      noExistingDetails: "No detailed item was returned for the already existing contacts.",
      noDuplicatedDetails: "No detailed item was returned for display, despite the duplicate count.",
      noErrorDetails: "No detailed item was returned for the errors.",
    },
  },
  contactNotes: {
    toasts: {
      added: "Note added successfully!",
      deleted: "Note deleted successfully!",
    },
    confirmation: {
      deleteTitle: "Delete Record",
      deleteMessage: "Do you really want to delete this record?",
    },
    editModal: {
      title: "Edit Note",
      label: "Edit Note",
    },
  },
  checkoutPage: {
    steps: {
      data: "Data",
      customize: "Customize",
      review: "Review",
    },
    notFound: "Not found",
    total: "TOTAL",
    copied: "Copied",
    copyPixQrCode: "Copy PIX QR code",
    usersCount: "{{count}} Users",
    connectionsCount: "{{count}} Connection",
    decreaseUsers: "Decrease users",
    increaseUsers: "Increase users",
    decreaseConnections: "Decrease connections",
    increaseConnections: "Increase connections",
    toasts: {
      subscriptionSuccess: "Subscription completed successfully, waiting for payment",
      licenseRenewed: "Your license has been renewed until {{date}}!",
    },
    form: {
      fullName: "Full name*",
      lastName: "Last name*",
      address: "Address*",
      city: "City*",
      state: "State*",
      document: "CPF/CNPJ*",
      country: "Country*",
      useAddressForPayment: "Use this address for payment details",
      nameOnCard: "Name on card*",
      cardNumber: "Card number*",
      expiryDate: "Expiry date*",
      cvv: "CVV*",
    },
    validation: {
      fullNameRequired: "Full name is required",
      lastNameRequired: "Last name is required",
      addressRequired: "Address is required",
      cityRequired: "City is required",
      stateRequired: "State is required",
      zipcodeRequired: "ZIP code is required",
      zipcodeInvalid: "Invalid ZIP code format",
      countryRequired: "Country is required",
      nameOnCardRequired: "Name on card is required",
      cardNumberRequired: "Card number is required",
      cardNumberInvalid: "Card number is not valid (e.g. 4111111111111)",
      expiryDateRequired: "Expiry date is required",
      expiryDateInvalid: "Expiry date is not valid",
      cvvRequired: "CVV is required",
      cvvInvalid: "CVV is invalid (e.g. 357)",
    },
    review: {
      paymentInfo: "Payment information",
      email: "Email:",
      name: "Name:",
      document: "CPF/CNPJ:",
      planDetails: "Plan details",
      users: "Users: {{count}}",
      connections: "Connection: {{count}}",
      queues: "Queues: {{count}}",
      billingMonthly: "Billing: Monthly",
    },
  },
  messagesList: {
    emptyNewContact: "Say hello to your new contact!",
    dropFileHere: "Drop the file here",
    unsupportedMediaType: "Unsupported media type",
    audioMessage: "Audio message",
  },
  floupSelector: {
    toasts: {
      stopped: "Follow UP stopped successfully",
    },
    stopFollowUp: "Stop Follow UP",
    active: "Active",
    nextSteps: "Next steps:",
    infoTitle: "Information about Follow UP",
    selectFollowUp: "Select Follow UP",
    chooseTemplate: "Choose template...",
    customTemplate: "custom",
    aboutTitle: "About the Follow UP System",
    aboutDescriptionPrefix: "The",
    aboutDescriptionSuffix: "lets you create message flows and assign them to a contact or ticket for automatic execution.",
    aboutHint: "Select an active template to start. You can stop it at any time.",
  },
  whatsAppModal: {
    defaultResponseFlow: {
      title: "Default response flow",
      description: "The Default Response is sent with any character different from a keyword. WARNING! It will be triggered if the service is already closed.",
    },
  },
  whatsAppModalAdmin: {
    toasts: {
      clickSaveToRegister: "Click save to register the changes",
    },
    tabs: {
      chatbot: "Chatbot",
    },
  },
  templateMetaModal: {
    title: "WhatsApp Templates",
    searchPlaceholder: "Search Templates",
    language: "Language: {{language}}",
    templateContent: "Template Content: {{content}}",
    category: "Category: {{category}}",
    selectedDetails: "Selected Template Details",
    name: "Name: {{name}}",
    content: "Content: {{content}}",
  },
  quickMessagesTable: {
    shortcut: "Shortcut",
    message: "Message",
  },
  contactListTable: {
    name: "Name",
    contacts: "Contacts",
  },
  queueOptions: {
    titlePlaceholder: "Option title",
    undefinedTitle: "Undefined title",
    messagePlaceholder: "Enter option text",
  },
});

mergeTranslations(messages.en.translations, {
  avatarUpload: {
    errors: {
      unsupportedFormat: "Unsupported file format. Use JPG, PNG, GIF, or WebP only.",
      fileTooLarge: "File is too large. Maximum size: 5MB",
    },
    alt: {
      userAvatar: "User avatar",
    },
    changeAvatar: "Change Avatar",
    uploadAvatar: "Upload Avatar",
  },
  notificationsVolume: {
    openNotifications: "Open notifications",
  },
  darkMode: {
    toggle: "Toggle dark mode",
  },
  ticketActionButtonsCustom: {
    toasts: {
      ticketClosed: "Ticket closed successfully!",
    },
    buttons: {
      createNewTicket: "Create New Ticket",
    },
    tooltips: {
      linkWallet: "Link to my wallet",
      copyPhoneWithPrefix: "Copy phone with prefix ({{prefix}})",
    },
    aria: {
      userMenu: "Current user account",
    },
  },
  speedDialButton: {
    openActionsMenu: "Open actions menu",
  },
  dashboard: {
    attendantsStatus: {
      online: "Online",
      offline: "Offline",
    },
  },
  wavoipCall: {
    connected: "Connected",
    disconnected: "Disconnected",
    minimize: "Minimize",
    enterNumber: "Enter a number",
    subtitle: "Make calls via WhatsApp",
    incomingCall: "Incoming call",
    unknownNumber: "Unknown number",
    callStatus: {
      inCall: "In call",
      connecting: "Connecting...",
      calling: "Calling...",
    },
    errors: {
      numberTooShort: "Number is too short",
      numberTooLong: "Number is too long",
      invalidNumber: "Invalid number",
    },
  },
  login: {
    aria: {
      togglePasswordVisibility: "Toggle password visibility",
    },
  },
  flowBuilder: {
    status: {
      active: "Active",
      inactive: "Inactive",
    },
    aria: {
      createFlow: "Create flow",
    },
  },
  chat: {
    aria: {
      mainMailboxFolders: "Main mailbox folders",
      more: "More",
    },
  },
  chatBots: {
    toasts: {
      saved: "Bot saved successfully",
      queueDeleted: "Queue deleted successfully!",
    },
    optionTypes: {
      text: "Text",
      attendant: "Attendant",
      queue: "Queue",
      integration: "Integration",
      file: "File",
    },
    tooltips: {
      messageRequired: "A message is required to continue to the next level",
      messageRequiredContent: "If the message is not set, the bot will not continue",
    },
  },
});

mergeTranslations(messages.en.translations, {
  campaignReport: {
    backButton: "Back",
    fetchError: "Error fetching report data",
  },
  compaies: {
    modal: {
      editTitle: "Edit Company",
    },
    table: {
      generateInvoice: "Generate Invoice",
    },
  },
  contactModal: {
    form: {
      assignWallet: "Customer Wallet",
    },
  },
  contacts: {
    table: {
      wallet: "Wallet",
    },
  },
  mainDrawer: {
    listItems: {
      callHistorical: "Call History",
    },
  },
  messageVariablesPicker: {
    vars: {
      scheduledDate: "Scheduled Date",
    },
  },
  notifications: {
    messageHidden: "Hidden message",
    newMessage: "New message from",
  },
  plans: {
    modal: {
      editTitle: "Edit Plan",
    },
  },
  queueModal: {
    form: {
      randomizeImmediate: "Randomize Automatically (Immediate)",
    },
  },
  quickMessages: {
    global: "Global",
    hasMedia: "With media",
    noQuickMessages: "No quick replies available",
    noResultsFound: "No quick replies found for your search",
    selectMessage: "Select Quick Reply",
  },
  settings: {
    settings: {
      options: {
        copyContactPrefix: "Contact Copy Prefix",
        copyContactPrefixPlaceholder: "E.g. COPY_",
        open: "Open",
        pending: "Pending",
        transferredTicketStatus: "Ticket status when transferring with user",
      },
    },
  },
  ticketInfo: {
    copyError: "Error copying phone",
    copyPhone: "Copy phone",
    noPhone: "No phone available to copy",
    phonecopied: "Phone copied to clipboard!",
    quickMessages: "Quick replies",
  },
  tickets: {
    messageHidden: "Hidden message",
    notification: {
      messageHidden: "Hidden message",
    },
  },
  triggerFlowModal: {
    cancel: "Cancel",
    description: "Select a flow to run on this ticket. The ticket will be changed to 'chatbot' status during execution.",
    error: "Error triggering flow",
    flowId: "Flow ID",
    noFlows: "No active flows found",
    selectFlow: "Choose a flow",
    selectedFlow: "Selected flow",
    success: "Flow triggered successfully!",
    title: "Trigger Flow",
    trigger: "Trigger Flow",
    triggering: "Triggering...",
  },
  userModal: {
    form: {
      allowSeeMessagesInPendingTickets: "Allow viewing pending tickets",
      showFlow: "View automations",
    },
  },
  wallets: {
    wallet: "Wallet",
  },
  whatsappModalRel: {
    form: {
      agent: "Agent",
      client: "Client",
      date: "Date",
      elementNotFoundForExport: "Element not found for export.",
      fullReport: "The full report was attached above",
      isOficial: "Service Report",
      lastMessage: "Last Message",
      number: "Number",
      reportFilename: "service_report",
      resolveAndTriggerIntegration: "Resolve and Trigger Integration",
      ticketId: "Ticket ID",
    },
  },
});

mergeTranslations(messages.en.translations, {
  mainDrawer: {
    listItems: {
      globalSearch: "Global Search",
    },
  },
  bootLoader: {
    loadingSubtitle: "Loading your experience...",
    initializingApplication: "Initializing application...",
    loadingComponents: "Loading components...",
    configuringInterface: "Configuring interface...",
    connectingServices: "Connecting services...",
    preparingSystem: "Preparing the system...",
    finishingLoading: "Finishing loading...",
  },
  tagsContainer: {
    placeholder: "Tags",
    loadingTags: "Loading tags...",
    noTagsFound: "No tag found. Type to create a new one.",
  },
  whitelabel: {
    loadingSettings: "Loading settings...",
  },
  billingEntitlements: {
    BILLING_RESOURCE_BLOCKED: "Resource blocked by plan.",
    PLAN_FEATURE_DISABLED: "This feature is not included in your plan.",
    PLAN_LIMIT_REACHED: "The plan limit has been reached.",
    PLAN_USER_LIMIT_REACHED: "Your plan reached the user limit.",
    PLAN_CONNECTION_LIMIT_REACHED: "Your plan reached the connection limit.",
    SUBSCRIPTION_NOT_ACTIVE: "Your subscription is not active.",
    SUBSCRIPTION_SUSPENDED: "Your subscription is suspended.",
    BILLING_MANUAL_REVIEW_REQUIRED: "This access requires manual review.",
    BILLING_STATUS_UNKNOWN: "Billing status requires review.",
    ENTITLEMENT_RESOLUTION_FAILED: "Access could not be validated right now.",
    CAMPAIGN_WAITING_FOR_BILLING: "Your campaign remains waiting until access is regularized.",
    SCHEDULE_WAITING_FOR_BILLING: "The schedule remains waiting for billing regularization."
  },
});

export { messages };
